import _defineProperty from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/regenerator";
import _toConsumableArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject45() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\x0Barphi"], ["\\varphi"]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["Powers of ", ":"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n", " \u2013 blue <br>\n", " \u2013 green <br>\n", " \u2013 yellow <br>\n", " \u2013 red <br>\n", " <br>\n", " <br>\n", " <br>\n", " <br>\n", " <br>\n", " <br>\n", " <br>\n", " <br>\n", " <br>\n", " <br>\n", " <br>\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["Test  \n", ""]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["<tr>\n      <td style=\"padding: .5em; text-align: right;\">", "</td>\n      <td style=\"padding: .5em; text-align: center;\">", "</td>\n      <td style=\"padding: .5em; text-align: center;\">", "</td>\n      <td style=\"padding: .5em; text-align: center;\">", "</td>\n      <td style=\"padding: .5em; text-align: center;\">", "</td>\n  </tr>"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n<table>\n", "\n</table>"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["Zomeball Vertices  \n", ""]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["Big Zomeball  \n", ""]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["Green  \n", ""]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["Red  \n", ""]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["Yellow  \n", ""]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["Blue  \n", ""]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n      \textcolor{#04f}{", "}colon!\n      \textcolor{#a90}{", "}colon!\n      \textcolor{#d03}{", "}"], ["\n      \\textcolor{#04f}{", "}\\colon\\!\n      \\textcolor{#a90}{", "}\\colon\\!\n      \\textcolor{#d03}{", "}"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["<tr>\n    <td style=\"padding: .5em; text-align: right;\">", "</td>\n    <td style=\"padding: .5em; text-align: center;\">", "</td>\n    <td style=\"padding: .5em; text-align: center;\">", "</td>\n    <td style=\"padding: .5em; text-align: center;\">", "</td></tr>"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["Quaternions and Matrices as Jacob might order them:<br>\n(But realistically I\u2019d probably want to think more about it)\n\n<table>\n", "\n</table>"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["<tr><td style=\"padding: .5em; text-align: right;\">", "</td>\n                     <td style=\"padding: .5em; text-align: center;\">", "</td>\n                     <td style=\"padding: .5em; text-align: center;\">", "</td>\n                ", "\n                 </tr>"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["Quaternions and Matrices for vZome directions:\n\n<table>\n", "\n</table>"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\nGiven any vector, we can rotate it in 60 distinct ways (including no\nrotation) and still preserve the symmetries of the icosahedron. These\ncan be composed of fifth-turn rotations around the icosahedron vertices,\nthird-turn\xA5 rotations around the centers of the icosahedron faces, and\nhalf-turn rotations around the centers of the icosahedron edges.\n\nIf we additionally reflect along any of those directions, we obtain\nan additional 60 \u201Cimproper rotations\u201D which still preserve icosahedral\nsymmetry.\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["Quaternions representing 1/5 turns about\n              ", ":<br><br>\n              ", ""]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["", "\begin{bmatrix} ", "end{bmatrix} "], ["", "\\begin{bmatrix} ", "\\end{bmatrix} "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["", "left langle ", "\right \rangle "], ["", "\\left \\langle ", "\\right \\rangle "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["left[", "\right]"], ["\\left[", "\\right]"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["* * *\n\n### Vectors\n\nFor the moment just do everything in terms of rationals.\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["left. 1 middle/ left(dfrac{a_0 + a_1\x0Barphi}{a_d}\right) \right. \\[.6em]\n  qquad = left(dfrac{a_0 + a_1 - a_1\x0Barphi}{a_0 + a_1 - a_1\x0Barphi}\right)\n           dfrac{a_d}{a_0 + a_1\x0Barphi} \\[.6em]\n  qquad = dfrac{(a_0 + a_1 - a_1\x0Barphi)a_d}\n                 {(a_0 + a_1)a_0 + (a_0 + a_1)a_1\x0Barphi - a_0a_1\x0Barphi - a_1^2\x0Barphi^2} \\[.6em]\n  qquad = dfrac{(a_0 + a_1)a_d - a_1a_d\x0Barphi}\n                 {a_0^2 + a_0a_1 - a_1^2}"], ["\\left. 1 \\middle/ \\left(\\dfrac{a_0 + a_1\\varphi}{a_d}\\right) \\right. \\\\[.6em]\n  \\qquad = \\left(\\dfrac{a_0 + a_1 - a_1\\varphi}{a_0 + a_1 - a_1\\varphi}\\right)\n           \\dfrac{a_d}{a_0 + a_1\\varphi} \\\\[.6em]\n  \\qquad = \\dfrac{(a_0 + a_1 - a_1\\varphi)a_d}\n                 {(a_0 + a_1)a_0 + (a_0 + a_1)a_1\\varphi - a_0a_1\\varphi - a_1^2\\varphi^2} \\\\[.6em]\n  \\qquad = \\dfrac{(a_0 + a_1)a_d - a_1a_d\\varphi}\n                 {a_0^2 + a_0a_1 - a_1^2}"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["left(dfrac{a_0 + a_1\x0Barphi}{a_d}\right)left(dfrac{b_0 + b_1\x0Barphi}{b_d}\right) \\[.6em]\n  qquad = dfrac{(a_0b_0 + a_1b_1) + (a_0b_1 + a_1b_0 + a_1b_1)\x0Barphi}{a_db_d}"], ["\\left(\\dfrac{a_0 + a_1\\varphi}{a_d}\\right)\\left(\\dfrac{b_0 + b_1\\varphi}{b_d}\\right) \\\\[.6em]\n  \\qquad = \\dfrac{(a_0b_0 + a_1b_1) + (a_0b_1 + a_1b_0 + a_1b_1)\\varphi}{a_db_d}"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["dfrac{a_0 + a_1\x0Barphi}{a_d} - dfrac{b_0 + b_1\x0Barphi}{b_d} \\[.6em]\n  qquad = dfrac{(a_0b_d - b_0a_d) + (a_1b_d - b_1a_d)\x0Barphi}{a_db_d}"], ["\\dfrac{a_0 + a_1\\varphi}{a_d} - \\dfrac{b_0 + b_1\\varphi}{b_d} \\\\[.6em]\n  \\qquad = \\dfrac{(a_0b_d - b_0a_d) + (a_1b_d - b_1a_d)\\varphi}{a_db_d}"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["dfrac{a_0 + a_1\x0Barphi}{a_d} + dfrac{b_0 + b_1\x0Barphi}{b_d} \\[.6em]\n  qquad = dfrac{(a_0b_d + b_0a_d) + (a_1b_d + b_1a_d)\x0Barphi}{a_db_d}"], ["\\dfrac{a_0 + a_1\\varphi}{a_d} + \\dfrac{b_0 + b_1\\varphi}{b_d} \\\\[.6em]\n  \\qquad = \\dfrac{(a_0b_d + b_0a_d) + (a_1b_d + b_1a_d)\\varphi}{a_db_d}"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["* * *\n### Golden Rationals "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["* * *"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n(a_0 + a_1\x0Barphi)(b_0 + b_1\x0Barphi) \\[.2em]\n  qquad = a_0b_0 + (a_0b_1 + a_1b_0)\x0Barphi + a_1b_1\x0Barphi^2 \\[.2em]\n  qquad = (a_0b_0 + a_1b_1) + (a_0b_1 + a_1b_0 + a_1b_1)\x0Barphi\n"], ["\n(a_0 + a_1\\varphi)(b_0 + b_1\\varphi) \\\\[.2em]\n  \\qquad = a_0b_0 + (a_0b_1 + a_1b_0)\\varphi + a_1b_1\\varphi^2 \\\\[.2em]\n  \\qquad = (a_0b_0 + a_1b_1) + (a_0b_1 + a_1b_0 + a_1b_1)\\varphi\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["(a_0 + a_1\x0Barphi) - (b_0 + b_1\x0Barphi) \\[.2em]\n  qquad = (a_0 - b_0) + (a_1 - b_1)\x0Barphi"], ["(a_0 + a_1\\varphi) - (b_0 + b_1\\varphi) \\\\[.2em]\n  \\qquad = (a_0 - b_0) + (a_1 - b_1)\\varphi"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["(a_0 + a_1\x0Barphi) + (b_0 + b_1\x0Barphi) \\[.2em]\n  qquad = (a_0 + b_0) + (a_1 + b_1)\x0Barphi"], ["(a_0 + a_1\\varphi) + (b_0 + b_1\\varphi) \\\\[.2em]\n  \\qquad = (a_0 + b_0) + (a_1 + b_1)\\varphi"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\x0Barphi = dfrac{1 + sqrt{5}}{2} approx ", ""], ["\\varphi = \\dfrac{1 + \\sqrt{5}}{2} \\approx ", ""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["", " ", " ", "\x0Barphi"], ["", " ", " ", "\\varphi"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\x0Barphi^2 = \x0Barphi + 1"], ["\\varphi^2 = \\varphi + 1"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\x0Barphi"], ["\\varphi"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["* * *\n\n### Golden Integers\n\nThe key property to know about the golden ratio ", " is that ", ".\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# Zome Arithmetic\n\n[Zome][] is a geometric construction system based on the symmetry system of\nthe icosahedron. Because of the pentagonal symmetries involved, the golden\nratio is fundamental to describing the metrical geometry of Zome shapes.\n\nFor the moment this notebook mostly sticks to business without a lot of\nexplanation.\n\n  [Zome]: https://en.wikipedia.org/wiki/Zome\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// https://observablehq.com/@jrus/zome-arithmetic@3375
import define1 from "../@vorth/wip-importing-vzome-shapes.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject());
  });
  main.variable(observer()).define(["md", "tex"], function (md, tex) {
    return md(_templateObject2(), tex(_templateObject3()), tex(_templateObject4()));
  });
  main.variable(observer("gprint")).define("gprint", ["tex"], function (tex) {
    return function gprint(a) {
      var _a = _slicedToArray(a, 2),
          a0 = _a[0],
          _a$ = _a[1],
          a1 = _a$ === void 0 ? 0 : _a$,
          sign = a1 > 0 ? '+' : '';

      return tex(_templateObject5(), a0, sign, a1);
    };
  });
  main.variable(observer()).define(["tex", "PHI"], function (tex, PHI) {
    return tex(_templateObject6(), PHI.toFixed(4));
  });
  main.variable(observer("PHI")).define("PHI", function () {
    return 0.5 * (Math.sqrt(5) + 1);
  });
  main.variable(observer("gfloat")).define("gfloat", ["PHI"], function (PHI) {
    return function gfloat(a) {
      var _a2 = _slicedToArray(a, 2),
          _a2$ = _a2[0],
          a0 = _a2$ === void 0 ? 0 : _a2$,
          _a2$2 = _a2[1],
          a1 = _a2$2 === void 0 ? 0 : _a2$2;

      return a0 + PHI * a1;
    };
  });
  main.variable(observer()).define(["tex"], function (tex) {
    return tex(_templateObject7());
  });
  main.variable(observer("gadd")).define("gadd", function () {
    return function gadd(a, b) {
      var _a3 = _slicedToArray(a, 2),
          _a3$ = _a3[0],
          a0 = _a3$ === void 0 ? 0 : _a3$,
          _a3$2 = _a3[1],
          a1 = _a3$2 === void 0 ? 0 : _a3$2,
          _b = _slicedToArray(b, 2),
          _b$ = _b[0],
          b0 = _b$ === void 0 ? 0 : _b$,
          _b$2 = _b[1],
          b1 = _b$2 === void 0 ? 0 : _b$2;

      return [a0 + b0, a1 + b1];
    };
  });
  main.variable(observer()).define(["tex"], function (tex) {
    return tex(_templateObject8());
  });
  main.variable(observer("gneg")).define("gneg", function () {
    return function gneg(a) {
      var _a4 = _slicedToArray(a, 2),
          _a4$ = _a4[0],
          a0 = _a4$ === void 0 ? 0 : _a4$,
          _a4$2 = _a4[1],
          a1 = _a4$2 === void 0 ? 0 : _a4$2;

      return [0 - a0, 0 - a1];
    };
  });
  main.variable(observer("gsub")).define("gsub", function () {
    return function gsub(a, b) {
      var _a5 = _slicedToArray(a, 2),
          _a5$ = _a5[0],
          a0 = _a5$ === void 0 ? 0 : _a5$,
          _a5$2 = _a5[1],
          a1 = _a5$2 === void 0 ? 0 : _a5$2,
          _b2 = _slicedToArray(b, 2),
          _b2$ = _b2[0],
          b0 = _b2$ === void 0 ? 0 : _b2$,
          _b2$2 = _b2[1],
          b1 = _b2$2 === void 0 ? 0 : _b2$2;

      return [a0 - b0, a1 - b1];
    };
  });
  main.variable(observer()).define(["tex"], function (tex) {
    return tex(_templateObject9());
  });
  main.variable(observer("gmul")).define("gmul", function () {
    return function gmul(a, b) {
      var _a6 = _slicedToArray(a, 2),
          _a6$ = _a6[0],
          a0 = _a6$ === void 0 ? 0 : _a6$,
          _a6$2 = _a6[1],
          a1 = _a6$2 === void 0 ? 0 : _a6$2,
          _b3 = _slicedToArray(b, 2),
          _b3$ = _b3[0],
          b0 = _b3$ === void 0 ? 0 : _b3$,
          _b3$2 = _b3[1],
          b1 = _b3$2 === void 0 ? 0 : _b3$2;

      return [a0 * b0 + a1 * b1, a0 * b1 + a1 * b0 + a1 * b1];
    };
  });
  main.variable(observer("gsign")).define("gsign", ["PHI"], function (PHI) {
    return function gsign(a) {
      var _a7 = _slicedToArray(a, 2),
          _a7$ = _a7[0],
          a0 = _a7$ === void 0 ? 0 : _a7$,
          _a7$2 = _a7[1],
          a1 = _a7$2 === void 0 ? 0 : _a7$2,
          _float = a0 + PHI * a1;

      return (_float > 0) - (_float < 0);
    };
  });
  main.variable(observer("gabs")).define("gabs", ["PHI"], function (PHI) {
    return function gabs(a) {
      var _a8 = _slicedToArray(a, 2),
          _a8$ = _a8[0],
          a0 = _a8$ === void 0 ? 0 : _a8$,
          _a8$2 = _a8[1],
          a1 = _a8$2 === void 0 ? 0 : _a8$2,
          _float2 = a0 + PHI * a1,
          sign = (_float2 > 0) - (_float2 < 0);

      return [a0 * sign, a1 * sign];
    };
  });
  main.variable(observer("gsquare")).define("gsquare", ["gmul"], function (gmul) {
    return function gsquare(x) {
      return gmul(x, x);
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject10());
  });
  main.variable(observer("gcd")).define("gcd", function () {
    return function gcd(a, b) {
      a = Math.abs(a), b = Math.abs(b);

      while (b != 0) {
        var _ref = [b, a % b];
        a = _ref[0];
        b = _ref[1];
      }

      return a;
    };
  });
  main.variable(observer("gcdc")).define("gcdc", function () {
    var cachesize = 0x400;
    var cache = new Uint16Array(cachesize * cachesize);

    for (var j = 0; j < cachesize; j++) {
      for (var i = 0; i < cachesize; i++) {
        var a = i,
            b = j;

        while (b != 0) {
          var _ref2 = [b, a % b];
          a = _ref2[0];
          b = _ref2[1];
        }

        cache[j * cachesize + i] = a;
      }
    }

    return function gcdc(a, b) {
      if ((a | 0) !== a || (b | 0) !== b) throw new TypeError('gcdc operates only on integers.');
      a *= (a > 0) - (a < 0), b *= (b > 0) - (b < 0); // absolute value

      while (a >= cachesize || b >= cachesize) {
        if (b == 0) return a;
        var _ref3 = [b, a % b];
        a = _ref3[0];
        b = _ref3[1];
      }

      return cache[b * cachesize + a];
    };
  });
  main.variable(observer("lcm")).define("lcm", ["gcd"], function (gcd) {
    return function lcm(a, b) {
      return a / gcd(a, b) * b;
    };
  });
  main.variable(observer("simplify")).define("simplify", ["gcd"], function (gcd) {
    return function simplify(vec) {
      var g = vec.reduce(gcd);
      return vec.map(function (x) {
        return x / g;
      });
    };
  });
  main.variable(observer("simplify3")).define("simplify3", ["gcdc", "gcd"], function (gcdc, gcd) {
    var cachesize = 0x80;
    var cache = new Uint8Array(cachesize * cachesize * cachesize * 3);

    for (var k = 0; k < cachesize; k++) {
      for (var j = 0; j < cachesize; j++) {
        for (var i = 0; i < cachesize; i++) {
          var g = gcdc(gcdc(i, j), k);
          var idx = ((k * cachesize + j) * cachesize + i) * 3;
          cache[idx] = i / g, cache[idx + 1] = j / g, cache[idx + 2] = k / g;
        }
      }
    }

    cache[0] = cache[1] = cache[2] = 0;
    return function simplify3(v0, v1, v2) {
      if ((v0 | 0) !== v0 || (v1 | 0) !== v1 || (v2 | 0) !== v2) throw new TypeError('simplify3 operates only on integers.');
      var s0 = (v0 > 0) - (v0 < 0),
          s1 = (v1 > 0) - (v1 < 0),
          s2 = (v2 > 0) - (v2 < 0); // signs

      v0 *= s0, v1 *= s1, v2 *= s2, s0 *= s2, s1 *= s2;

      if (v0 < cachesize && v1 < cachesize && v2 < cachesize) {
        var _idx = ((v2 * cachesize + v1) * cachesize + v0) * 3;

        return [s0 * cache[_idx], s1 * cache[_idx + 1], cache[_idx + 2]];
      }

      var g = gcd(gcd(v0, v1), v2);
      return [s0 * v0 / g, s1 * v1 / g, v2 / g];
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject11());
  });
  main.variable(observer("grprintraw")).define("grprintraw", function () {
    return function grprintraw(a) {
      var _a9 = _slicedToArray(a, 3),
          _a9$ = _a9[0],
          a0 = _a9$ === void 0 ? 0 : _a9$,
          _a9$2 = _a9[1],
          a1 = _a9$2 === void 0 ? 0 : _a9$2,
          _a9$3 = _a9[2],
          ad = _a9$3 === void 0 ? 1 : _a9$3,
          sign = a1 >= 0 ? '+' : '';

      var numer = a1 == 0 ? "".concat(a0) : a0 == 0 && a1 == 1 ? "\\varphi" : a0 == 0 && a1 == -1 ? "- \\varphi" : // (a0 == 1 && a1 == -1) ? `- \\varphi^{-}` :
      // (a0 == -1 && a1 == 1) ? `\\varphi^{-}` :
      a0 == 0 ? "".concat(a1, "\\varphi") : a1 == 1 ? "".concat(a0, " + \\varphi") : a1 == -1 ? "".concat(a0, " - \\varphi") : a1 < 0 ? "".concat(a0, " ").concat(a1, "\\varphi") : "".concat(a0, " + ").concat(a1, "\\varphi");
      return ad == 1 ? numer : "\\dfrac{".concat(numer, "}{").concat(ad, "}");
    };
  });
  main.variable(observer("grprint")).define("grprint", ["tex", "grprintraw"], function (tex, grprintraw) {
    return function grprint(a) {
      return tex(_templateObject12(), grprintraw(a));
    };
  });
  main.variable(observer("grfloat")).define("grfloat", ["PHI"], function (PHI) {
    return function grfloat(a) {
      var _a10 = _slicedToArray(a, 3),
          _a10$ = _a10[0],
          a0 = _a10$ === void 0 ? 0 : _a10$,
          _a10$2 = _a10[1],
          a1 = _a10$2 === void 0 ? 0 : _a10$2,
          _a10$3 = _a10[2],
          ad = _a10$3 === void 0 ? 1 : _a10$3;

      return (a0 + PHI * a1) / ad;
    };
  });
  main.variable(observer()).define(["tex"], function (tex) {
    return tex(_templateObject13());
  });
  main.variable(observer("gradd")).define("gradd", ["simplify3"], function (simplify3) {
    return function gradd(a, b) {
      var _a11 = _slicedToArray(a, 3),
          _a11$ = _a11[0],
          a0 = _a11$ === void 0 ? 0 : _a11$,
          _a11$2 = _a11[1],
          a1 = _a11$2 === void 0 ? 0 : _a11$2,
          _a11$3 = _a11[2],
          ad = _a11$3 === void 0 ? 1 : _a11$3,
          _b4 = _slicedToArray(b, 3),
          _b4$ = _b4[0],
          b0 = _b4$ === void 0 ? 0 : _b4$,
          _b4$2 = _b4[1],
          b1 = _b4$2 === void 0 ? 0 : _b4$2,
          _b4$3 = _b4[2],
          bd = _b4$3 === void 0 ? 1 : _b4$3;

      return simplify3(a0 * bd + b0 * ad, a1 * bd + b1 * ad, ad * bd);
    };
  });
  main.variable(observer("grsum")).define("grsum", ["gradd"], function (gradd) {
    return function grsum(vec) {
      return vec.reduce(gradd, [0]);
    };
  });
  main.variable(observer()).define(["tex"], function (tex) {
    return tex(_templateObject14());
  });
  main.variable(observer("grneg")).define("grneg", function () {
    return function grneg(a) {
      var _a12 = _slicedToArray(a, 3),
          _a12$ = _a12[0],
          a0 = _a12$ === void 0 ? 0 : _a12$,
          _a12$2 = _a12[1],
          a1 = _a12$2 === void 0 ? 0 : _a12$2,
          _a12$3 = _a12[2],
          ad = _a12$3 === void 0 ? 1 : _a12$3;

      return [0 - a0, 0 - a1, ad];
    };
  });
  main.variable(observer("grsub")).define("grsub", ["simplify3"], function (simplify3) {
    return function grsub(a, b) {
      var _a13 = _slicedToArray(a, 3),
          _a13$ = _a13[0],
          a0 = _a13$ === void 0 ? 0 : _a13$,
          _a13$2 = _a13[1],
          a1 = _a13$2 === void 0 ? 0 : _a13$2,
          _a13$3 = _a13[2],
          ad = _a13$3 === void 0 ? 1 : _a13$3,
          _b5 = _slicedToArray(b, 3),
          _b5$ = _b5[0],
          b0 = _b5$ === void 0 ? 0 : _b5$,
          _b5$2 = _b5[1],
          b1 = _b5$2 === void 0 ? 0 : _b5$2,
          _b5$3 = _b5[2],
          bd = _b5$3 === void 0 ? 1 : _b5$3;

      return simplify3(a0 * bd - b0 * ad, a1 * bd - b1 * ad, ad * bd);
    };
  });
  main.variable(observer()).define(["tex"], function (tex) {
    return tex(_templateObject15());
  });
  main.variable(observer("grmul")).define("grmul", ["simplify3"], function (simplify3) {
    return function grmul(a, b) {
      var _a14 = _slicedToArray(a, 3),
          _a14$ = _a14[0],
          a0 = _a14$ === void 0 ? 0 : _a14$,
          _a14$2 = _a14[1],
          a1 = _a14$2 === void 0 ? 0 : _a14$2,
          _a14$3 = _a14[2],
          ad = _a14$3 === void 0 ? 1 : _a14$3,
          _b6 = _slicedToArray(b, 3),
          _b6$ = _b6[0],
          b0 = _b6$ === void 0 ? 0 : _b6$,
          _b6$2 = _b6[1],
          b1 = _b6$2 === void 0 ? 0 : _b6$2,
          _b6$3 = _b6[2],
          bd = _b6$3 === void 0 ? 1 : _b6$3;

      return simplify3(a0 * b0 + a1 * b1, a0 * b1 + a1 * b0 + a1 * b1, ad * bd);
    };
  });
  main.variable(observer()).define(["tex"], function (tex) {
    return tex(_templateObject16());
  });
  main.variable(observer("grinv")).define("grinv", ["simplify3"], function (simplify3) {
    return function grinv(a) {
      var _a15 = _slicedToArray(a, 3),
          _a15$ = _a15[0],
          a0 = _a15$ === void 0 ? 0 : _a15$,
          _a15$2 = _a15[1],
          a1 = _a15$2 === void 0 ? 0 : _a15$2,
          _a15$3 = _a15[2],
          ad = _a15$3 === void 0 ? 1 : _a15$3;

      return simplify3((a0 + a1) * ad, 0 - a1 * ad, a0 * a0 + a0 * a1 - a1 * a1);
    };
  });
  main.variable(observer("grdiv")).define("grdiv", ["grmul", "grinv"], function (grmul, grinv) {
    return function grdiv(a, b) {
      return grmul(a, grinv(b));
    };
  });
  main.variable(observer("grsign")).define("grsign", ["PHI"], function (PHI) {
    return function grsign(a) {
      var _a16 = _slicedToArray(a, 3),
          _a16$ = _a16[0],
          a0 = _a16$ === void 0 ? 0 : _a16$,
          _a16$2 = _a16[1],
          a1 = _a16$2 === void 0 ? 0 : _a16$2,
          _a16$3 = _a16[2],
          ad = _a16$3 === void 0 ? 1 : _a16$3,
          _float3 = a0 + PHI * a1;

      return ((ad > 0) - (ad < 0)) * ((_float3 > 0) - (_float3 < 0));
    };
  });
  main.variable(observer("grabs")).define("grabs", ["PHI"], function (PHI) {
    return function grabs(a) {
      var _a17 = _slicedToArray(a, 3),
          _a17$ = _a17[0],
          a0 = _a17$ === void 0 ? 0 : _a17$,
          _a17$2 = _a17[1],
          a1 = _a17$2 === void 0 ? 0 : _a17$2,
          _a17$3 = _a17[2],
          ad = _a17$3 === void 0 ? 1 : _a17$3,
          _float4 = a0 + PHI * a1,
          sign = ((ad > 0) - (ad < 0)) * ((_float4 > 0) - (_float4 < 0));

      return [a0 * sign, a1 * sign, ad];
    };
  });
  main.variable(observer("grgreater")).define("grgreater", ["PHI"], function (PHI) {
    return function grgreater(a, b) {
      var _a18 = _slicedToArray(a, 3),
          _a18$ = _a18[0],
          a0 = _a18$ === void 0 ? 0 : _a18$,
          _a18$2 = _a18[1],
          a1 = _a18$2 === void 0 ? 0 : _a18$2,
          _a18$3 = _a18[2],
          ad = _a18$3 === void 0 ? 1 : _a18$3,
          _b7 = _slicedToArray(b, 3),
          _b7$ = _b7[0],
          b0 = _b7$ === void 0 ? 0 : _b7$,
          _b7$2 = _b7[1],
          b1 = _b7$2 === void 0 ? 0 : _b7$2,
          _b7$3 = _b7[2],
          bd = _b7$3 === void 0 ? 1 : _b7$3;

      return a0 * bd - b0 * ad + PHI * (a1 * bd - b1 * ad) > 0;
    };
  });
  main.variable(observer("grsquare")).define("grsquare", ["grmul"], function (grmul) {
    return function grsquare() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
      return grmul(x, x);
    };
  });
  main.variable(observer("grpow")).define("grpow", ["grinv", "grmul"], function (grinv, grmul) {
    return function grpow(x, n) {
      if (n < 0) x = grinv(x), n = -n;
      var acc = [1];

      for (var i = 0; i < n; i++) {
        acc = grmul(x, acc);
      }

      return acc;
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject17());
  });
  main.variable(observer("vprint")).define("vprint", ["tex", "grprintraw"], function (tex, grprintraw) {
    return function vprint(v) {
      return tex(_templateObject18(), v.map(grprintraw).join(','));
    };
  });
  main.variable(observer("quatprint")).define("quatprint", ["lcm", "grprintraw", "grmul", "tex"], function (lcm, grprintraw, grmul, tex) {
    return function quatprint(v) {
      v = _toConsumableArray(v.values()).map(function () {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
            _ref5 = _slicedToArray(_ref4, 3),
            _ref5$ = _ref5[0],
            a0 = _ref5$ === void 0 ? 0 : _ref5$,
            _ref5$2 = _ref5[1],
            a1 = _ref5$2 === void 0 ? 0 : _ref5$2,
            _ref5$3 = _ref5[2],
            ad = _ref5$3 === void 0 ? 1 : _ref5$3;

        return [a0, a1, ad];
      });
      var denom = v.map(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 3),
            ad = _ref7[2];

        return ad;
      });
      var denom_lcm = denom.reduce(lcm);
      var fraction = denom_lcm == 1 ? '' : grprintraw([1,, denom_lcm]);
      v = v.map(function (a, i) {
        return grmul(a, [denom_lcm]);
      });
      return tex(_templateObject19(), fraction, v.map(grprintraw).join(','));
    };
  });
  main.variable(observer("mat33print")).define("mat33print", ["lcm", "grprintraw", "grmul", "tex"], function (lcm, grprintraw, grmul, tex) {
    return function mat33print(M) {
      M = _toConsumableArray(M.values()).map(function () {
        var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
            _ref9 = _slicedToArray(_ref8, 3),
            _ref9$ = _ref9[0],
            a0 = _ref9$ === void 0 ? 0 : _ref9$,
            _ref9$2 = _ref9[1],
            a1 = _ref9$2 === void 0 ? 0 : _ref9$2,
            _ref9$3 = _ref9[2],
            ad = _ref9$3 === void 0 ? 1 : _ref9$3;

        return [a0, a1, ad];
      });
      var denom = M.map(function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 3),
            ad = _ref11[2];

        return ad;
      });
      var denom_lcm = denom.reduce(lcm);
      var fraction = denom_lcm == 1 ? '' : grprintraw([1,, denom_lcm]);
      M = M.map(function (a, i) {
        return grmul(a, [denom_lcm]);
      });
      var matrix = M.map(function (a, i) {
        return grprintraw(a) + ((i - 2) % 3 ? "&" : "\\\\");
      }).join('');
      return tex(_templateObject20(), fraction, matrix);
    };
  });
  main.variable(observer("quadrance")).define("quadrance", ["grsquare", "gradd"], function (grsquare, gradd) {
    return function quadrance(v) {
      return _toConsumableArray(v.values()).map(grsquare).reduce(gradd, [0]);
    };
  });
  main.variable(observer("scalarmul")).define("scalarmul", ["grmul"], function (grmul) {
    return function scalarmul(s, v) {
      return _toConsumableArray(v.values()).map(function () {
        var vi = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
        return grmul(s, vi);
      });
    };
  });
  main.variable(observer("vectoradd")).define("vectoradd", ["gradd"], function (gradd) {
    return function vectoradd(u, v) {
      return _toConsumableArray(u.values()).map(function () {
        var ui = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
        var i = arguments.length > 1 ? arguments[1] : undefined;
        return gradd(ui, v[i] || [0]);
      });
    };
  });
  main.variable(observer("vectorsub")).define("vectorsub", ["grsub"], function (grsub) {
    return function vectorsub(u, v) {
      return _toConsumableArray(u.values()).map(function () {
        var ui = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
        var i = arguments.length > 1 ? arguments[1] : undefined;
        return grsub(ui, v[i] || [0]);
      });
    };
  });
  main.variable(observer("dot")).define("dot", ["grmul", "gradd"], function (grmul, gradd) {
    return function dot(u, v) {
      return _toConsumableArray(u.values()).map(function () {
        var ui = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0];
        var i = arguments.length > 1 ? arguments[1] : undefined;
        return grmul(ui, v[i] || [0]);
      }).reduce(gradd, [0]);
    };
  });
  main.variable(observer("wedge")).define("wedge", ["grmul", "grsub"], function (grmul, grsub) {
    return function wedge(u, v) {
      var x = grmul,
          s = grsub,
          _u = _slicedToArray(u, 3),
          u0 = _u[0],
          u1 = _u[1],
          u2 = _u[2],
          _v = _slicedToArray(v, 3),
          v0 = _v[0],
          v1 = _v[1],
          v2 = _v[2];

      return [s(x(u1, v2), x(u2, v1)), s(x(u2, v0), x(u0, v2)), s(x(u0, v1), x(u1, v0))];
    };
  });
  main.variable(observer("spread")).define("spread", ["grsub", "grdiv", "grsquare", "dot", "grmul", "quadrance"], function (grsub, grdiv, grsquare, dot, grmul, quadrance) {
    return function spread(u, v) {
      return grsub([1], grdiv(grsquare(dot(u, v)), grmul(quadrance(u), quadrance(v))));
    };
  });
  main.variable(observer("transform")).define("transform", ["grmul", "gradd"], function (grmul, gradd) {
    return function transform(M, v) {
      // Apply 3x3 linear transformation matrix M to 3x1 vector v.
      var _M = _slicedToArray(M, 9),
          m00 = _M[0],
          m01 = _M[1],
          m02 = _M[2],
          m10 = _M[3],
          m11 = _M[4],
          m12 = _M[5],
          m20 = _M[6],
          m21 = _M[7],
          m22 = _M[8];

      var _v2 = _slicedToArray(v, 3),
          _v2$ = _v2[0],
          v0 = _v2$ === void 0 ? [0] : _v2$,
          _v2$2 = _v2[1],
          v1 = _v2$2 === void 0 ? [0] : _v2$2,
          _v2$3 = _v2[2],
          v2 = _v2$3 === void 0 ? [0] : _v2$3,
          x = grmul,
          a = gradd;

      return [a(a(x(v0, m00), x(v1, m01)), x(v2, m02)), a(a(x(v0, m10), x(v1, m11)), x(v2, m12)), a(a(x(v0, m20), x(v1, m21)), x(v2, m22))];
    };
  });
  main.variable(observer("quatmul")).define("quatmul", ["grmul", "gradd", "grsub"], function (grmul, gradd, grsub) {
    return function quatmul(u, v) {
      var x = grmul,
          a = gradd,
          s = grsub,
          _u2 = _slicedToArray(u, 4),
          _u2$ = _u2[0],
          u0 = _u2$ === void 0 ? [0] : _u2$,
          _u2$2 = _u2[1],
          u1 = _u2$2 === void 0 ? [0] : _u2$2,
          _u2$3 = _u2[2],
          u2 = _u2$3 === void 0 ? [0] : _u2$3,
          _u2$4 = _u2[3],
          u3 = _u2$4 === void 0 ? [0] : _u2$4,
          _v3 = _slicedToArray(v, 4),
          _v3$ = _v3[0],
          v0 = _v3$ === void 0 ? [0] : _v3$,
          _v3$2 = _v3[1],
          v1 = _v3$2 === void 0 ? [0] : _v3$2,
          _v3$3 = _v3[2],
          v2 = _v3$3 === void 0 ? [0] : _v3$3,
          _v3$4 = _v3[3],
          v3 = _v3$4 === void 0 ? [0] : _v3$4;

      return [s(x(u0, v0), a(a(x(u1, v1), x(u2, v2)), x(u3, v3))), a(a(x(u0, v1), x(u1, v0)), s(x(u2, v3), x(u3, v2))), a(a(x(u0, v2), x(u2, v0)), s(x(u3, v1), x(u1, v3))), a(a(x(u0, v3), x(u3, v0)), s(x(u1, v2), x(u2, v1)))];
    };
  });
  main.variable(observer("quatconj")).define("quatconj", ["grneg"], function (grneg) {
    return function quatconj(_ref12) {
      var _ref13 = _slicedToArray(_ref12, 4),
          _ref13$ = _ref13[0],
          u0 = _ref13$ === void 0 ? [0] : _ref13$,
          _ref13$2 = _ref13[1],
          u1 = _ref13$2 === void 0 ? [0] : _ref13$2,
          _ref13$3 = _ref13[2],
          u2 = _ref13$3 === void 0 ? [0] : _ref13$3,
          _ref13$4 = _ref13[3],
          u3 = _ref13$4 === void 0 ? [0] : _ref13$4;

      return [u0, grneg(u1), grneg(u2), grneg(u3)];
    };
  });
  main.variable(observer("quatnormalize")).define("quatnormalize", ["scalarmul", "grsign"], function (scalarmul, grsign) {
    return function quatnormalize(q) {
      return scalarmul([q.map(grsign).reduce(function (a, b) {
        return a || b;
      }) || 1], q);
    };
  });
  main.variable(observer("quattransform")).define("quattransform", ["quatmul", "quatconj"], function (quatmul, quatconj) {
    return function quattransform(Q, v) {
      return quatmul(Q, quatmul([[0]].concat(v), quatconj(Q))).slice(1);
    };
  });
  main.variable(observer()).define(["quatmul", "html", "vprint"], function (quatmul, html, vprint) {
    var red = [[[1], [0], [0], [0]], [[0, 1, 2], [-1, 1, 2], [0, 0, 1], [1, 0, 2]]];

    for (var i = 2; i < 10; i++) {
      red[i] = quatmul(red[i - 1], red[1]);
    }

    return html(_templateObject21(), vprint([[1], [0], [0, 1]]), red.map(vprint));
  });
  main.variable(observer("red_rotation")).define("red_rotation", function () {
    return [[0, 1, 2], [-1, 1, 2], [1, 0, 2], // 1 [ φ   φ⁻  1 ]
    [-1, 1, 2], [1, 0, 2], [0, -1, 2], // - [ φ⁻  1  −φ ]
    [-1, 0, 2], [0, 1, 2], [-1, 1, 2]];
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject22());
  });
  main.variable(observer("icosahedral_symmetry")).define("icosahedral_symmetry", ["scalarmul", "grneg", "transform", "red_rotation"], function (scalarmul, grneg, transform, red_rotation) {
    return function icosahedral_symmetry(v) {
      v = scalarmul([1], v); // fill in any missing values

      var output = [];

      for (var i = 0; i < 5; i++) {
        var _v4 = v,
            _v5 = _slicedToArray(_v4, 3),
            x = _v5[0],
            y = _v5[1],
            z = _v5[2],
            _v$map = v.map(grneg),
            _v$map2 = _slicedToArray(_v$map, 3),
            x_ = _v$map2[0],
            y_ = _v$map2[1],
            z_ = _v$map2[2];

        output.push([x, y, z], [x, y_, z_], [x_, y, z_], [x_, y_, z], [z, x, y], [z, x_, y_], [z_, x, y_], [z_, x_, y], [y, z, x], [y, z_, x_], [y_, z, x_], [y_, z_, x]);
        v = transform(red_rotation, v);
      }

      return output;
    };
  });
  main.variable(observer("icosahedral_quaternions")).define("icosahedral_quaternions", ["quatmul", "scalarmul", "grsign"], function (quatmul, scalarmul, grsign) {
    var cartesian_product = function cartesian_product(u, v) {
      var _ref14;

      return (_ref14 = []).concat.apply(_ref14, _toConsumableArray(u.map(function (a) {
        return v.map(function (b) {
          return quatmul(a, b);
        });
      })));
    };

    var one = [[1],,,],
        h = [1,, 2],
        blue = [one, [, [1],,], [,, [1]], [,,, [1]]],
        yellow = [one, [h, h, h, h], [[-1,, 2], h, h, h]],
        red = [one, [[, 1, 2], [-1, 1, 2],, h]];

    for (var i = 2; i < 5; i++) {
      red[i] = quatmul(red[i - 1], red[1]);
    }

    return [blue, yellow, red].reduce(cartesian_product).map(function (q) {
      return scalarmul([grsign(q[0]) || grsign(q[1]) || 1], q);
    });
  });
  main.variable(observer("icosahedral_quaternions_vzome")).define("icosahedral_quaternions_vzome", ["quatmul", "quatnormalize"], function (quatmul, quatnormalize) {
    var one = [[1],,,],
        h = [1,, 2],
        blue = [one, [, [1],,], [,,, [1]], [,, [1]]],
        yellow = [one, [h, h, h, h], [[-1,, 2], h, h, h]],
        red = [one, [[, 1, 2], h, [-1, 1, 2]]];

    for (var i = 2; i < 5; i++) {
      red[i] = quatmul(red[i - 1], red[1]);
    }

    var output = [];
    var b, r, y;

    for (var _i = 0, _blue = blue; _i < _blue.length; _i++) {
      b = _blue[_i];

      for (var _i2 = 0, _red = red; _i2 < _red.length; _i2++) {
        r = _red[_i2];

        for (var _i3 = 0, _yellow = yellow; _i3 < _yellow.length; _i3++) {
          y = _yellow[_i3];
          output.push(quatnormalize(quatmul(b, quatmul(y, r))));
        }
      }
    }

    return output;
  });
  main.variable(observer("quat2matrix")).define("quat2matrix", ["quatconj", "quatmul"], function (quatconj, quatmul) {
    return function quat2matrix(Q) {
      var Q_ = quatconj(Q),
          _quatmul = quatmul(Q, quatmul([, [1],,], Q_)),
          _quatmul2 = _slicedToArray(_quatmul, 4),
          m_0 = _quatmul2[0],
          m00 = _quatmul2[1],
          m10 = _quatmul2[2],
          m20 = _quatmul2[3],
          _quatmul3 = quatmul(Q, quatmul([,, [1]], Q_)),
          _quatmul4 = _slicedToArray(_quatmul3, 4),
          m_1 = _quatmul4[0],
          m01 = _quatmul4[1],
          m11 = _quatmul4[2],
          m21 = _quatmul4[3],
          _quatmul5 = quatmul(Q, quatmul([,,, [1]], Q_)),
          _quatmul6 = _slicedToArray(_quatmul5, 4),
          m_2 = _quatmul6[0],
          m02 = _quatmul6[1],
          m12 = _quatmul6[2],
          m22 = _quatmul6[3];

      return [m00, m01, m02, m10, m11, m12, m20, m21, m22];
    };
  });
  main.variable(observer("scott_matrices")).define("scott_matrices", ["golden_icosahedral_symmetry"], function (golden_icosahedral_symmetry) {
    return golden_icosahedral_symmetry.matrices.map(function (rows) {
      var _ref15;

      return (_ref15 = []).concat.apply(_ref15, _toConsumableArray(rows));
    });
  });
  main.variable(observer("orbitnames")).define("orbitnames", ["golden_icosahedral_symmetry"], function (golden_icosahedral_symmetry) {
    return Object.entries(golden_icosahedral_symmetry.orbits).reduce(function (acc, _ref16) {
      var _ref17 = _slicedToArray(_ref16, 2),
          name = _ref17[0],
          canonical = _ref17[1].canonical;

      return acc[canonical] = name, acc;
    }, {});
  });
  main.variable(observer()).define(["mat33print", "red_rotation"], function (mat33print, red_rotation) {
    return mat33print(red_rotation);
  });
  main.variable(observer()).define(["quatprint", "icosahedral_quaternions_vzome"], function (quatprint, icosahedral_quaternions_vzome) {
    return quatprint(icosahedral_quaternions_vzome[3]);
  });
  main.variable(observer()).define(["html", "icosahedral_quaternions_vzome", "tex", "quatprint", "mat33print", "quat2matrix"], function (html, icosahedral_quaternions_vzome, tex, quatprint, mat33print, quat2matrix) {
    return html(_templateObject23(), icosahedral_quaternions_vzome.map(function (q, i) {
      return html(_templateObject24(), tex(_templateObject25(), i), quatprint(q), mat33print(quat2matrix(q)),
      /* <td style="padding: .5em; text-align: center;">${mat33print(scott_matrices[i])}</td> */
      '');
    }));
  });
  main.variable(observer()).define(["html", "icosahedral_quaternions", "tex", "quatprint", "mat33print", "quat2matrix"], function (html, icosahedral_quaternions, tex, quatprint, mat33print, quat2matrix) {
    return html(_templateObject26(), icosahedral_quaternions.map(function (q, i) {
      return html(_templateObject27(), tex(_templateObject28(), i), tex(_templateObject29(), Math.floor(i / 15) % 4, Math.floor(i / 5) % 3, i % 5), quatprint(q), mat33print(quat2matrix(q)));
    }));
  });
  main.variable(observer()).define(["md", "deduplicate", "icosahedral_symmetry", "vprint"], function (md, deduplicate, icosahedral_symmetry, vprint) {
    return md(_templateObject30(), deduplicate(icosahedral_symmetry([[2], [0], [0]])).map(vprint));
  });
  main.variable(observer()).define(["md", "deduplicate", "icosahedral_symmetry", "vprint"], function (md, deduplicate, icosahedral_symmetry, vprint) {
    return md(_templateObject31(), deduplicate(icosahedral_symmetry([[1], [1], [1]])).map(vprint));
  });
  main.variable(observer()).define(["md", "deduplicate", "icosahedral_symmetry", "vprint"], function (md, deduplicate, icosahedral_symmetry, vprint) {
    return md(_templateObject32(), deduplicate(icosahedral_symmetry([[, 1], [1], [0]])).map(vprint));
  });
  main.variable(observer()).define(["md", "deduplicate", "icosahedral_symmetry", "vprint"], function (md, deduplicate, icosahedral_symmetry, vprint) {
    return md(_templateObject33(), deduplicate(icosahedral_symmetry([[2], [2], [0]])).map(vprint));
  });
  main.variable(observer()).define(["md", "deduplicate", "icosahedral_symmetry", "vprint"], function (md, deduplicate, icosahedral_symmetry, vprint) {
    return md(_templateObject34(), deduplicate(icosahedral_symmetry([[2, 2], [, 1], [1]])).map(vprint));
  });
  main.variable(observer()).define(["md", "deduplicate", "icosahedral_symmetry", "vprint"], function (md, deduplicate, icosahedral_symmetry, vprint) {
    return md(_templateObject35(), deduplicate(icosahedral_symmetry([[1, 0, 1], [-1, 1, 2], [2, -1, 2]])).map(vprint));
  });
  main.variable(observer("deduplicate")).define("deduplicate", function () {
    return function deduplicate(array) {
      var set = new Set();
      return array.filter(function (item) {
        if (set.has(JSON.stringify(item))) return false;
        set.add(JSON.stringify(item));
        return true;
      });
    };
  });
  main.variable(observer("orbit")).define("orbit", ["grabs", "transform", "red_rotation", "dot", "grmul", "grgreater", "vectoradd", "scalarmul", "grinv"], function (grabs, transform, red_rotation, dot, grmul, grgreater, vectoradd, scalarmul, grinv) {
    var v = [[-1, 1], [-1], [0, -1]]; //  φ⁻ -1  -φ

    return function orbit(u) {
      // Reduce to the 'kite' shape at the corner of one octant:
      u = u.map(grabs); // absolute value of each coordinate

      u = transform(red_rotation, u).map(grabs);
      u = transform(red_rotation, u).map(grabs); // Now reflect the top triangle of the kite onto the bottom triangle:

      var d = dot(u, v);
      d = grmul([-grgreater([0], d), 0, 2], d);
      u = vectoradd(u, scalarmul(d, v)); // Now return rational coordinates of a gnomonic (tangent) projection.

      return scalarmul(grinv(u[0]), [u[1], u[2]]);
    };
  });
  main.variable(observer("transform_in_place")).define("transform_in_place", ["simplify3"], function (simplify3) {
    var x = function grmul(a, b) {
      var _a19 = _slicedToArray(a, 3),
          a0 = _a19[0],
          a1 = _a19[1],
          ad = _a19[2],
          _b8 = _slicedToArray(b, 3),
          b0 = _b8[0],
          b1 = _b8[1],
          bd = _b8[2];

      return simplify3(a0 * b0 + a1 * b1, a0 * b1 + a1 * b0 + a1 * b1, ad * bd);
    };

    var a = function gradd3(a, b, c) {
      var _a20 = _slicedToArray(a, 3),
          a0 = _a20[0],
          a1 = _a20[1],
          ad = _a20[2],
          _b9 = _slicedToArray(b, 3),
          b0 = _b9[0],
          b1 = _b9[1],
          bd = _b9[2],
          _c = _slicedToArray(c, 3),
          c0 = _c[0],
          c1 = _c[1],
          cd = _c[2];

      return simplify3(a0 * bd * cd + b0 * ad * cd + c0 * ad * bd, a1 * bd * cd + b1 * ad * cd + c1 * ad * bd, ad * bd * cd);
    };

    return function transform_in_place(M, v) {
      // Apply 3x3 linear transformation matrix M to 3x1 vector v, return v.
      var _M2 = _slicedToArray(M, 9),
          m00 = _M2[0],
          m01 = _M2[1],
          m02 = _M2[2],
          m10 = _M2[3],
          m11 = _M2[4],
          m12 = _M2[5],
          m20 = _M2[6],
          m21 = _M2[7],
          m22 = _M2[8];

      var _v6 = _slicedToArray(v, 3),
          v0 = _v6[0],
          v1 = _v6[1],
          v2 = _v6[2];

      v[0] = a(x(v0, m00), x(v1, m01), x(v2, m02));
      v[1] = a(x(v0, m10), x(v1, m11), x(v2, m12));
      v[2] = a(x(v0, m20), x(v1, m21), x(v2, m22));
      return v;
    };
  });
  main.variable(observer("orbit2")).define("orbit2", ["PHI", "range", "quatmul", "grsign", "scalarmul", "transform", "red_rotation", "dot", "grgreater", "grmul", "vectoradd", "grinv"], function (PHI, range, quatmul, grsign, scalarmul, transform, red_rotation, dot, grgreater, grmul, vectoradd, grinv) {
    // Copy and normalize a golden rational.
    var grcopy = function grcopy() {
      var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
          _ref19 = _slicedToArray(_ref18, 3),
          _ref19$ = _ref19[0],
          x0 = _ref19$ === void 0 ? 0 : _ref19$,
          _ref19$2 = _ref19[1],
          x1 = _ref19$2 === void 0 ? 0 : _ref19$2,
          _ref19$3 = _ref19[2],
          xd = _ref19$3 === void 0 ? 1 : _ref19$3;

      return [x0, x1, xd];
    }; // Return (a < 0); as a side effect, change a to abs(a), in place.


    var lt0_abs = function lt0_abs(a) {
      var _float5 = a[0] + PHI * a[1],
          sign = (_float5 > 0) - (_float5 < 0);

      a[0] *= sign;
      a[1] *= sign;
      return +(sign < 0);
    }; // Parity of the count of ones of an 8-bit integer in binary


    var hamming_parity = function hamming_parity(n) {
      n -= n >> 1 & 0x55;
      n -= n >> 2 & 0x33;
      return n - (n >> 4) & 0x01;
    }; // Build up a lookup table for reflection bit patterns -> quaternions


    var orbit_quaternions = _toConsumableArray(range(0x100)).map(function (rb) {
      var quat = [[1],,,];
      if (rb & 0x80) quat = quatmul(quat, [, [1],,]);
      if (rb & 0x40) quat = quatmul(quat, [,, [1]]);
      if (rb & 0x20) quat = quatmul(quat, [,,, [1]]);
      quat = quatmul(quat, [[, 1, 2], [-1,, 2], [1, -1, 2]]); // conjugate of red_rotation

      if (rb & 0x10) quat = quatmul(quat, [,, [1]]);
      if (rb & 0x08) quat = quatmul(quat, [,,, [1]]);
      quat = quatmul(quat, [[, 1, 2], [-1,, 2], [1, -1, 2]]);
      if (rb & 0x04) quat = quatmul(quat, [,, [1]]);
      if (rb & 0x02) quat = quatmul(quat, [,,, [1]]);
      if (rb & 0x01) quat = quatmul(quat, [, [-1, 1, 2], [-1,, 2], [, -1, 2]]);
      var sign = quat.map(grsign).reduce(function (a, b) {
        return a || b;
      }) || 1;
      return scalarmul([sign], quat);
    });

    var v = [[-1, 1], [-1], [, -1]]; //  φ⁻ -1  -φ
    // Find the orbit and orientation for a vector u.

    return function orbit2(u) {
      u = [grcopy(u[0]), grcopy(u[1]), grcopy(u[2])]; // Make a deep copy of 'u'.
      // Reduce to the 'kite' shape at the corner of one octant:

      var rbits = [lt0_abs(u[0]), lt0_abs(u[1]), lt0_abs(u[2])]; // rbits = reflection bits

      u = transform(red_rotation, u);
      rbits.push(lt0_abs(u[1]), lt0_abs(u[2]));
      u = transform(red_rotation, u);
      rbits.push(lt0_abs(u[1]), lt0_abs(u[2])); // Now reflect the top triangle of the kite onto the bottom triangle:

      var d = dot(u, v),
          ds = +grgreater([0], d);
      rbits.push(ds);
      d = grmul([-ds, 0, 2], d);
      u = vectoradd(u, scalarmul(d, v));
      var orb = scalarmul(grinv(u[0]), [u[1], u[2]]); // coordinates of gnomonic projection

      var rbits_int = rbits.reduce(function (a, b) {
        return (a << 1) + b;
      });
      var rotation = orbit_quaternions[rbits_int];
      var length = u[0];
      var reflected = hamming_parity(rbits_int);
      return [orb, rotation, reflected, length];
    };
  });
  main.variable(observer()).define(["orbit2"], function (orbit2) {
    return orbit2([[0], [0], [0]]);
  });
  main.variable(observer()).define(["html", "icosahedral_quaternions_vzome", "quattransform", "orbit2", "scalarmul", "tex", "quatprint"], function (html, icosahedral_quaternions_vzome, quattransform, orbit2, scalarmul, tex, quatprint) {
    return html(_templateObject36(), icosahedral_quaternions_vzome.map(function (q, i) {
      var vv = [[5, -3], [2, -1], [2, 0]]; // const v = [[1,0,1]].concat(orbit2(vv)[0]);  // [[1],[0],[0]] // [[1],[2,-1],[5,-3]]; // [[1], [2,-1,2],[-3,2,2]]; // [[1],[0],[2,-1]] // [[1],[-1,1],[0]] // 

      var v = [[1], [2, -1], [5, -3]];
      var qv = quattransform(q, v);

      var _orbit = orbit2(qv),
          _orbit2 = _slicedToArray(_orbit, 3),
          o = _orbit2[0],
          qvr = _orbit2[1],
          reflect = _orbit2[2];

      var qv2 = scalarmul([1 - 2 * reflect], quattransform(qvr, v));
      return html(_templateObject37(), tex(_templateObject38(), i), quatprint(q), quatprint(qvr), quatprint(qv), quatprint(qv2));
    }));
  });
  main.variable(observer()).define(["quattransform"], function (quattransform) {
    return quattransform([[0, 1, 2], [1, 0, 2], [-1, 1, 2], [0, 0, 1]], [[1, 0, 1], [2, -1, 2], [-3, 2, 2]]);
  });
  var child1 = runtime.module(define1);
  main.import("golden_icosahedral_symmetry", child1);
  main.variable(observer("test_orbits")).define("test_orbits", function () {
    return [[[1, 0, 1], [2, -1, 2], [-3, 2, 2]], // "turquoise" RYB
    [[1, 0, 1], [2, -1, 1], [5, -3, 1]], // "green"     YR
    [[1, 0, 1], [0, 0, 1], [-4, 3, 5]], // "rose"      YB
    [[1, 0, 1], [2, -1, 1], [0, 0, 1]], // "purple"    RB
    [[1, 0, 1], [-1, 1, 1], [0, 0, 1]], // "red"       R
    [[1, 0, 1], [0, 0, 1], [2, -1, 1]], // "yellow"    Y
    [[1, 0, 1], [0, 0, 1], [0, 0, 1]]];
  });
  main.variable(observer()).define(["md", "deduplicate", "icosahedral_symmetry", "vprint"], function (md, deduplicate, icosahedral_symmetry, vprint) {
    return md(_templateObject39(), deduplicate(icosahedral_symmetry([[1], [-8, 5], [5, -3]])).map(vprint));
  });
  main.variable(observer()).define(["md", "icosahedral_quaternions_vzome", "quattransform", "vprint"], function (md, icosahedral_quaternions_vzome, quattransform, vprint) {
    return md(_templateObject40(), icosahedral_quaternions_vzome.map(function (q) {
      return quattransform(q, [[3], [2, -1], [5, -3]]);
    }).map(vprint));
  });
  main.variable(observer()).define(["vprint", "orbit"], function (vprint, orbit) {
    return vprint(orbit([[3], [2, -1], [5, -3]]));
  });
  main.variable(observer()).define(["vprint", "orbit"], function (vprint, orbit) {
    return vprint(orbit([[3], [2, -1], [5, -3]]));
  });
  main.variable(observer()).define(["vprint", "orbit"], function (vprint, orbit) {
    return vprint(orbit([[2], [0], [0]]));
  });
  main.variable(observer()).define(["vprint", "orbit"], function (vprint, orbit) {
    return vprint(orbit([[-1, 1], [1], [, 1]]));
  });
  main.variable(observer()).define(["vprint", "orbit"], function (vprint, orbit) {
    return vprint(orbit([[1], [1], [1]]));
  });
  main.variable(observer()).define(["vprint", "orbit"], function (vprint, orbit) {
    return vprint(orbit([[1], [1, 1], [0]]));
  });
  main.variable(observer()).define(["vprint", "orbit"], function (vprint, orbit) {
    return vprint(orbit([[, 1], [1], [0]]));
  });
  main.variable(observer()).define(["vprint", "orbit"], function (vprint, orbit) {
    return vprint(orbit([[2], [2], [0]]));
  });
  main.variable(observer()).define(["vprint", "orbit"], function (vprint, orbit) {
    return vprint(orbit([[1], [-8, 5], [5, -3]]));
  });
  main.variable(observer()).define(["orbit", "grfloat"], function (orbit, grfloat) {
    return orbit([[1], [1, 1], [0]]).map(grfloat);
  });
  main.variable(observer()).define(["orbit", "grfloat"], function (orbit, grfloat) {
    return orbit([[, 1], [1], [0]]).map(grfloat);
  });
  main.variable(observer()).define(["md", "vprint", "orbit"], function (md, vprint, orbit) {
    return md(_templateObject41(), vprint(orbit([[1], [0], [0]])), vprint(orbit([[1], [1], [0]])), vprint(orbit([[1], [-1, 1], [0]])), vprint(orbit([[1], [1, 1], [0]])), vprint(orbit([[1], [1, 2], [0]])), vprint(orbit([[1], [0, 1], [0]])), vprint(orbit([[1, 1], [1], [0]])), vprint(orbit([[1, 2], [1], [0]])), vprint(orbit([[2, 3], [1], [0]])), vprint(orbit([[2], [1], [0]])), vprint(orbit([[1], [2], [0]])), vprint(orbit([[2], [-1, 1], [0]])), vprint(orbit([[-1, 1], [2], [0]])), vprint(orbit([[2], [1, 1], [0]])), vprint(orbit([[1, 1], [2], [0]])));
  });
  main.variable(observer()).define(["md", "tex"], function (md, tex) {
    return md(_templateObject42(), tex(_templateObject43()));
  });
  main.variable(observer()).define(["vprint", "range", "grpow"], function (vprint, range, grpow) {
    return vprint(_toConsumableArray(range(10)).map(function (i) {
      return grpow([, 1], i);
    }));
  });
  main.variable(observer()).define(["vprint", "range", "grpow"], function (vprint, range, grpow) {
    return vprint(_toConsumableArray(range(10)).map(function (i) {
      return grpow([, 1], -i);
    }));
  });
  main.variable(observer("parseAlgebraicNumber")).define("parseAlgebraicNumber", ["simplify3"], function (simplify3) {
    return function parseAlgebraicNumber(_ref20) {
      var _ref21 = _slicedToArray(_ref20, 3),
          _ref21$ = _ref21[0],
          a0 = _ref21$ === void 0 ? 0 : _ref21$,
          _ref21$2 = _ref21[1],
          a1 = _ref21$2 === void 0 ? 0 : _ref21$2,
          _ref21$3 = _ref21[2],
          ad = _ref21$3 === void 0 ? 1 : _ref21$3;

      var d0 = 1,
          d1 = 1;

      if (!(typeof a0 === "number")) {
        var _a0$split$map = a0.split('/').map(Number);

        var _a0$split$map2 = _slicedToArray(_a0$split$map, 2);

        a0 = _a0$split$map2[0];
        d0 = _a0$split$map2[1];
      }

      if (!(typeof a1 === "number")) {
        var _a1$split$map = a1.split('/').map(Number);

        var _a1$split$map2 = _slicedToArray(_a1$split$map, 2);

        a1 = _a1$split$map2[0];
        d1 = _a1$split$map2[1];
      }

      return simplify3(a0 * d1, a1 * d0, d0 * d1 * ad);
    };
  });
  main.variable(observer("range")).define("range", function () {
    return function range(n) {
      return _defineProperty({}, Symbol.iterator,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < n)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return i;

              case 4:
                i++;
                _context.next = 1;
                break;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };
  });
  main.variable(observer()).define(["solid_connectors", "orbit2", "quattransform", "quatconj", "scalarmul"], function (solid_connectors, orbit2, quattransform, quatconj, scalarmul) {
    var shapejson = JSON.parse(JSON.stringify(solid_connectors)); // deep copy

    return Object.entries(shapejson.strutGeometries).map(function (_ref23) {
      var _ref24 = _slicedToArray(_ref23, 2),
          name = _ref24[0],
          strut = _ref24[1];

      var _orbit3 = orbit2(strut.prototypeVector),
          _orbit4 = _slicedToArray(_orbit3, 4),
          orb = _orbit4[0],
          rotation = _orbit4[1],
          reflected = _orbit4[2],
          length = _orbit4[3];

      var vertices = strut.vertices.map(function (v) {
        v = quattransform(quatconj(rotation), v);
        return reflected ? scalarmul([-1], v) : v;
      });
      var outstrut = Object.assign({
        'name': name
      }, strut, {
        'vertices': vertices,
        'prototypeVector': [[1, 0, 0]].concat(orb)
      });
      return [JSON.stringify(orb), outstrut];
    }).reduce(function (map, _ref25) {
      var _ref26 = _slicedToArray(_ref25, 2),
          key = _ref26[0],
          val = _ref26[1];

      return map[key] = val, map;
    }, {});
  });
  main.variable(observer("solid_connectors")).define("solid_connectors", function () {
    return {
      "name": "solid connectors",
      "connectorShape": {
        "vertices": [[[-1, 1, 2], [0, -1, 2], [-1, 1, 1]], [[0, 1, 2], [1, -1, 1], [-1, 1, 2]], [[-1, 1, 1], [1, -1, 2], [0, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[-1, 1, 1], [-1, 1, 2], [0, 1, 2]], [[0, 1, 2], [0, 0, 1], [3, -1, 2]], [[2, -1, 2], [-1, 0, 1], [-1, 1, 2]], [[-2, 1, 2], [-1, 0, 1], [-1, 1, 2]], [[-2, 1, 2], [-1, 0, 1], [1, -1, 2]], [[2, -1, 2], [-1, 0, 1], [1, -1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, 1, 2], [1, -1, 1], [1, -1, 2]], [[-1, 1, 1], [1, -1, 2], [0, -1, 2]], [[0, 1, 2], [0, 0, 1], [-3, 1, 2]], [[0, 0, 1], [3, -1, 2], [0, -1, 2]], [[-1, 1, 2], [0, 1, 2], [1, -1, 1]], [[-1, 1, 1], [-1, 1, 2], [0, -1, 2]], [[-1, 1, 2], [2, -1, 2], [-1, 0, 1]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, -1, 2], [0, -1, 2], [-1, 1, 1]], [[0, 0, 1], [-3, 1, 2], [0, 1, 2]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[-3, 1, 2], [0, 1, 2], [0, 0, 1]], [[0, -1, 2], [-1, 1, 1], [-1, 1, 2]], [[1, -1, 2], [0, 1, 2], [-1, 1, 1]], [[-2, 1, 2], [1, 0, 1], [-1, 1, 2]], [[-1, 1, 2], [-2, 1, 2], [-1, 0, 1]], [[2, -1, 2], [1, 0, 1], [-1, 1, 2]], [[-1, 1, 2], [0, 1, 2], [-1, 1, 1]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[0, 0, 1], [3, -1, 2], [0, 1, 2]], [[-1, 1, 2], [0, -1, 2], [1, -1, 1]], [[0, 0, 1], [-3, 1, 2], [0, -1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, -1, 2], [0, 0, 1], [3, -1, 2]], [[1, -1, 1], [-1, 1, 2], [0, 1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, -1, 2], [0, -1, 2], [1, -1, 1]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[2, -1, 2], [1, 0, 1], [1, -1, 2]], [[0, -1, 2], [-1, 1, 1], [1, -1, 2]], [[-2, 1, 2], [1, 0, 1], [1, -1, 2]], [[1, -1, 2], [0, 1, 2], [1, -1, 1]], [[1, -1, 1], [1, -1, 2], [0, 1, 2]], [[-1, 1, 2], [2, -1, 2], [1, 0, 1]], [[1, -1, 2], [2, -1, 2], [-1, 0, 1]], [[1, -1, 2], [2, -1, 2], [1, 0, 1]], [[1, -1, 2], [-2, 1, 2], [1, 0, 1]], [[-1, 1, 2], [-2, 1, 2], [1, 0, 1]], [[3, -1, 2], [0, -1, 2], [0, 0, 1]], [[0, -1, 2], [0, 0, 1], [-3, 1, 2]], [[1, -1, 1], [1, -1, 2], [0, -1, 2]], [[1, -1, 2], [-2, 1, 2], [-1, 0, 1]], [[1, -1, 1], [-1, 1, 2], [0, -1, 2]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]]],
        "polygons": [[9, 40, 35, 34, 10], [0, 1, 2], [33, 51, 49], [25, 36, 37, 38], [41, 55, 42], [9, 32, 59, 40], [20, 21, 52, 48], [26, 33, 30, 29, 27], [3, 4, 5, 6], [27, 29, 44, 46], [50, 57, 56, 55, 58], [26, 38, 51, 33], [45, 47, 58], [18, 28, 57, 50], [40, 59, 56], [31, 48, 37, 43], [7, 8, 9, 10], [36, 41, 42, 43], [24, 46, 47, 45], [4, 30, 5], [15, 47, 46, 44, 16], [15, 50, 58, 47], [24, 45, 41, 36, 25], [11, 14, 19], [3, 6, 39], [1, 39, 6, 2], [8, 32, 9], [11, 12, 13, 14], [16, 22, 17], [0, 21, 20, 8, 7], [12, 34, 13], [35, 40, 56, 57], [0, 7, 54, 1], [15, 16, 17, 18], [3, 19, 22, 23, 4], [7, 10, 54], [41, 45, 58, 55], [3, 39, 11, 19], [14, 17, 22, 19], [0, 2, 53, 21], [49, 51, 52, 53], [31, 43, 42, 59, 32], [15, 18, 50], [42, 55, 56, 59], [4, 23, 29, 30], [25, 38, 26], [13, 28, 18, 17, 14], [8, 20, 31, 32], [23, 44, 29], [24, 27, 46], [37, 48, 52, 51, 38], [20, 48, 31], [24, 25, 26, 27], [16, 44, 23, 22], [13, 34, 35, 28], [10, 34, 12, 54], [2, 6, 5, 49, 53], [36, 43, 37], [5, 30, 33, 49], [1, 54, 12, 11, 39], [28, 35, 57], [21, 53, 52]]
      },
      "strutGeometries": {
        "cinnamon": {
          "prototypeVector": [[5, -3, 1], [2, -1, 1], [2, 0, 1]],
          "fullScaleVertices": [16, 0, 1, 2, 3, 4, 5, 11, 12],
          "halfScaleVertices": [],
          "vertices": [[[6, -4, 1], [3, -2, 1], [1, -2, 1]], [[1, -1, 2], [2, -1, 2], [-1, 0, 1]], [[-1, 1, 2], [2, -1, 2], [-1, 0, 1]], [[5, -3, 1], [3, -2, 1], [1, -2, 1]], [[5, -3, 1], [1, -1, 1], [1, -2, 1]], [[-1, 1, 2], [-2, 1, 2], [-1, 0, 1]], [[1, -1, 2], [-2, 1, 2], [1, 0, 1]], [[-1, 1, 2], [-2, 1, 2], [1, 0, 1]], [[-6, 4, 1], [-3, 2, 1], [-1, 2, 1]], [[-5, 3, 1], [-3, 2, 1], [-1, 2, 1]], [[-6, 4, 1], [-1, 1, 1], [-1, 2, 1]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[6, -4, 1], [1, -1, 1], [1, -2, 1]], [[-5, 3, 1], [-1, 1, 1], [-1, 2, 1]], [[-1, 1, 2], [2, -1, 2], [1, 0, 1]], [[1, -1, 2], [2, -1, 2], [1, 0, 1]], [[1, -1, 2], [-2, 1, 2], [-1, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [6, 7, 8, 9], [4, 3, 2, 5], [4, 8, 10, 3], [13, 10, 14, 15], [9, 8, 4, 12], [12, 4, 5, 16], [0, 3, 10, 13], [12, 0, 13, 9], [7, 14, 10, 8], [12, 16, 1, 0], [9, 13, 15, 6]]
        },
        "green": {
          "prototypeVector": [[1, 1, 2], [1, 0, 2], [-2, 1, 2]],
          "fullScaleVertices": [0, 1, 2, 18, 3, 4, 8, 9, 10, 11],
          "halfScaleVertices": [],
          "vertices": [[[-2, -3, 4], [-5, 1, 4], [7, -4, 4]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[-2, -3, 4], [-5, 1, 4], [15, -8, 4]], [[-6, -1, 4], [-7, 3, 4], [13, -8, 4]], [[-6, -1, 4], [-7, 3, 4], [21, -12, 4]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[6, 1, 4], [7, -3, 4], [-13, 8, 4]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[2, 3, 4], [5, -1, 4], [-7, 4, 4]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[6, 1, 4], [7, -3, 4], [-21, 12, 4]], [[2, 3, 4], [5, -1, 4], [-15, 8, 4]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2], [5, 6, 7], [3, 8, 9], [4, 2, 10, 11], [12, 7, 2, 4], [13, 5, 12], [7, 14, 0, 2], [14, 15, 3, 0], [15, 12, 4, 3], [1, 10, 2], [9, 0, 3], [9, 1, 0], [16, 13, 15], [13, 12, 15], [6, 17, 14, 7], [3, 4, 11, 8], [5, 7, 12], [17, 16, 15, 14]]
        },
        "navy": {
          "prototypeVector": [[-1, 2, 1], [1, 1, 1], [0, 0, 1]],
          "fullScaleVertices": [0, 16, 4, 5, 6, 7, 8, 9, 10, 12],
          "halfScaleVertices": [],
          "vertices": [[[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[11, -3, 4], [3, 2, 4], [6, -3, 4]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[-13, 5, 4], [3, -6, 4], [-6, 3, 4]], [[-13, 5, 4], [3, -6, 4], [6, -3, 4]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-11, 3, 4], [-3, -2, 4], [-6, 3, 4]], [[13, -5, 4], [-3, 6, 4], [6, -3, 4]], [[-11, 3, 4], [-3, -2, 4], [6, -3, 4]], [[13, -5, 4], [-3, 6, 4], [-6, 3, 4]], [[11, -3, 4], [3, 2, 4], [-6, 3, 4]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]]],
          "polygons": [[1, 2, 3], [6, 5, 7], [9, 8, 10], [10, 8, 6], [8, 5, 6], [11, 1, 7, 12], [13, 10, 6, 14], [15, 14, 1, 3], [12, 7, 16], [13, 17, 11], [16, 7, 5], [2, 1, 11], [11, 17, 2], [13, 18, 17], [18, 14, 15], [7, 1, 14, 6], [13, 14, 18], [10, 12, 4, 9], [4, 12, 16], [10, 13, 11, 12]]
        },
        "black": {
          "prototypeVector": [[-1, 3, 2], [1, 0, 2], [-2, 1, 2]],
          "fullScaleVertices": [1, 2, 4, 5, 6, 7, 11, 12, 14],
          "halfScaleVertices": [],
          "vertices": [[[-1, 3, 2], [0, 1, 2], [0, 0, 1]], [[1, -3, 2], [-2, 1, 2], [2, -1, 1]], [[1, -3, 2], [-2, 1, 2], [0, 0, 1]], [[-1, 3, 2], [0, 1, 2], [-2, 1, 1]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, -3, 2], [0, -1, 2], [2, -1, 1]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, 3, 2], [2, -1, 2], [0, 0, 1]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, -3, 2], [0, -1, 2], [0, 0, 1]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 3, 2], [2, -1, 2], [-2, 1, 1]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]]],
          "polygons": [[0, 1, 2, 3], [5, 6, 7, 1], [8, 9, 0, 10], [11, 2, 12, 4], [13, 11, 5, 9], [4, 6, 5, 11], [3, 2, 11, 13], [15, 13, 9, 8], [3, 13, 15, 16], [16, 10, 0, 3], [9, 5, 1, 0], [1, 7, 12, 2]]
        },
        "yellow": {
          "prototypeVector": [[1, 1, 1], [0, 0, 1], [-1, 0, 1]],
          "fullScaleVertices": [4, 9, 11, 12],
          "halfScaleVertices": [2, 3, 6, 7, 8, 10],
          "vertices": [[[0, 1, 2], [0, 0, 1], [-3, 1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, -1, 2], [-1, 1, 2], [1, 0, 2]], [[-1, 0, 1], [0, 0, 1], [0, 0, 1]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, -1, 2], [1, -1, 2], [1, 0, 2]], [[0, 1, 2], [-1, 1, 2], [-1, 0, 2]], [[1, 0, 1], [0, 0, 1], [0, 0, 1]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[0, 1, 2], [1, -1, 2], [-1, 0, 2]], [[0, -1, 2], [0, 0, 1], [3, -1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]]],
          "polygons": [[0, 1, 2, 3], [5, 0, 3, 6], [3, 2, 7], [2, 6, 8], [6, 3, 10], [10, 7, 4, 12], [1, 5, 6, 2], [7, 8, 11, 4], [10, 8, 6], [8, 10, 12, 11], [8, 7, 2], [7, 10, 3]]
        },
        "turquoise": {
          "prototypeVector": [[2, 0, 1], [2, -1, 1], [-3, 2, 1]],
          "fullScaleVertices": [0, 16, 1, 10, 11, 12, 13, 14, 15],
          "halfScaleVertices": [],
          "vertices": [[[1, -2, 1], [3, -2, 2], [-9, 5, 2]], [[1, -2, 1], [5, -4, 2], [-9, 5, 2]], [[-1, 2, 1], [-3, 2, 2], [5, -3, 2]], [[-1, 2, 1], [-5, 4, 2], [5, -3, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 2, 1], [-5, 4, 2], [9, -5, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, 2, 1], [-3, 2, 2], [9, -5, 2]], [[1, -2, 1], [5, -4, 2], [-5, 3, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, -2, 1], [3, -2, 2], [-5, 3, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]]],
          "polygons": [[0, 1, 2, 3], [2, 4, 5, 3], [6, 7, 8, 9], [11, 12, 10, 13], [9, 10, 12, 6], [9, 8, 4, 2], [15, 16, 1, 0], [2, 1, 10, 9], [0, 12, 11, 15], [3, 5, 7, 6], [13, 10, 1, 16], [0, 3, 6, 12]]
        },
        "brown": {
          "prototypeVector": [[-1, 1, 1], [-1, 1, 1], [-2, 2, 1]],
          "fullScaleVertices": [0, 16, 1, 6, 7, 8, 13, 14, 15],
          "halfScaleVertices": [],
          "vertices": [[[1, -1, 2], [-2, 1, 2], [-1, 0, 1]], [[-1, 0, 2], [-1, 0, 1], [0, -1, 1]], [[1, 0, 2], [1, 0, 1], [0, 1, 1]], [[0, 1, 2], [-1, 2, 2], [-2, 3, 2]], [[-1, 1, 2], [0, 1, 2], [-1, 1, 1]], [[0, 0, 1], [3, -1, 2], [0, 1, 2]], [[0, -1, 2], [1, -2, 2], [2, -3, 2]], [[1, -1, 2], [0, -1, 2], [1, -1, 1]], [[1, -2, 2], [1, -1, 1], [0, -1, 1]], [[-1, 1, 2], [2, -1, 2], [1, 0, 1]], [[-1, 1, 1], [-1, 1, 2], [0, 1, 2]], [[-1, 2, 2], [-1, 1, 1], [0, 1, 1]], [[0, 1, 2], [1, 0, 2], [2, 1, 2]], [[1, -1, 1], [1, -1, 2], [0, -1, 2]], [[0, -1, 2], [-1, 0, 2], [-2, -1, 2]], [[0, 0, 1], [-3, 1, 2], [0, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[2, 3, 4, 5], [9, 10, 11, 12], [3, 11, 10, 4], [7, 13, 8, 6], [14, 1, 11, 3], [0, 15, 1, 14], [12, 2, 5, 9], [13, 0, 14, 8], [6, 1, 15, 7], [8, 14, 3, 2], [6, 8, 2, 12], [12, 11, 1, 6]]
        },
        "orange": {
          "prototypeVector": [[2, 1, 2], [-1, 1, 2], [-1, 0, 2]],
          "fullScaleVertices": [0, 1, 2, 6, 7, 8, 10, 14],
          "halfScaleVertices": [],
          "vertices": [[[-2, -1, 2], [1, -1, 1], [3, -1, 2]], [[0, -1, 2], [0, 0, 1], [3, -1, 2]], [[0, -1, 1], [1, -1, 2], [0, 1, 2]], [[2, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[2, 1, 2], [0, 0, 1], [1, -1, 2]], [[-2, -1, 2], [0, 0, 1], [-1, 1, 2]], [[-2, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, 1, 1], [-1, 1, 2], [0, -1, 2]], [[0, 1, 2], [0, 0, 1], [-3, 1, 2]], [[2, 1, 2], [-1, 1, 1], [-3, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3, 4, 5], [1, 8, 6, 2], [3, 9, 4], [8, 10, 7], [5, 11, 7, 10, 0], [12, 11, 5, 4], [6, 8, 7, 11, 12, 13], [13, 9, 3, 2, 6], [10, 1, 0], [12, 9, 13]]
        },
        "red": {
          "prototypeVector": [[0, 1, 1], [1, 0, 1], [0, 0, 1]],
          "fullScaleVertices": [16, 17, 18, 19, 7, 12],
          "halfScaleVertices": [0, 1, 2, 20, 5, 6, 8, 9, 10, 11],
          "vertices": [[[0, -1, 2], [-2, 1, 1], [-1, 1, 2]], [[0, 1, 2], [2, -1, 1], [-1, 1, 2]], [[-1, 1, 1], [3, -1, 2], [2, -1, 2]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[3, -3, 2], [-2, 1, 2], [0, 0, 1]], [[0, -1, 2], [-2, 1, 1], [1, -1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[1, -1, 1], [-3, 1, 2], [2, -1, 2]], [[1, -1, 1], [-3, 1, 2], [-2, 1, 2]], [[-3, 3, 2], [2, -1, 2], [0, 0, 1]], [[0, 1, 2], [2, -1, 1], [1, -1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[-1, 1, 1], [3, -1, 2], [-2, 1, 2]]],
          "polygons": [[0, 1, 2], [3, 4, 5, 6], [8, 9, 10], [9, 11, 10], [13, 14, 9, 8], [4, 15, 0, 5], [2, 1, 7, 16], [0, 8, 1], [14, 3, 6, 9], [8, 10, 1], [9, 6, 11], [5, 0, 2], [11, 20, 18, 17], [20, 2, 16, 18], [6, 5, 20], [1, 10, 12, 7], [6, 20, 11], [15, 13, 8, 0], [10, 11, 17, 12], [5, 2, 20]]
        },
        "apple": {
          "prototypeVector": [[5, -3, 1], [1, 0, 1], [0, 1, 1]],
          "fullScaleVertices": [0, 1, 4, 7, 8, 9, 10, 13, 14],
          "halfScaleVertices": [],
          "vertices": [[[1, -1, 4], [-3, 0, 4], [-6, -1, 4]], [[-1, 1, 4], [-5, 0, 4], [-2, -3, 4]], [[-3, 3, 4], [-3, 4, 4], [2, 3, 4]], [[-1, 1, 4], [-1, 4, 4], [-2, 5, 4]], [[1, -1, 2], [-2, 1, 2], [-1, 0, 1]], [[1, -1, 4], [5, 0, 4], [2, 3, 4]], [[-1, 1, 4], [3, 0, 4], [6, 1, 4]], [[1, -1, 4], [1, -4, 4], [2, -5, 4]], [[3, -3, 4], [3, -4, 4], [-2, -3, 4]], [[1, -1, 2], [0, -1, 2], [1, -1, 1]], [[0, 0, 1], [-3, 1, 2], [0, -1, 2]], [[0, 0, 1], [3, -1, 2], [0, 1, 2]], [[-1, 1, 2], [2, -1, 2], [1, 0, 1]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[1, -1, 1], [1, -1, 2], [0, -1, 2]], [[-1, 1, 1], [-1, 1, 2], [0, 1, 2]], [[-1, 1, 2], [0, 1, 2], [-1, 1, 1]]],
          "polygons": [[0, 1, 2, 3], [5, 6, 7, 8], [4, 10, 1, 0], [11, 12, 6, 5], [3, 5, 8, 0], [6, 2, 1, 7], [7, 1, 10, 9], [8, 7, 9, 14], [15, 2, 6, 12], [16, 11, 5, 3], [0, 8, 14, 4], [3, 2, 15, 16]]
        },
        "sand": {
          "prototypeVector": [[-2, 2, 1], [-2, 2, 1], [2, 0, 1]],
          "fullScaleVertices": [0, 16, 1, 2, 3, 6, 11, 12, 13],
          "halfScaleVertices": [],
          "vertices": [[[1, -1, 2], [0, -1, 2], [1, -1, 1]], [[1, -1, 2], [-2, 1, 2], [-1, 0, 1]], [[-1, -1, 2], [0, -1, 2], [0, -1, 1]], [[-1, 0, 1], [-3, 1, 2], [-2, -1, 2]], [[1, 0, 1], [1, 1, 2], [-2, 3, 2]], [[3, -1, 2], [4, -1, 2], [0, 1, 1]], [[1, -1, 1], [1, -1, 2], [0, -1, 2]], [[-1, 1, 2], [0, 1, 2], [-1, 1, 1]], [[0, 0, 1], [3, -1, 2], [0, 1, 2]], [[1, 1, 2], [0, 1, 2], [0, 1, 1]], [[-1, 1, 1], [-1, 1, 2], [0, 1, 2]], [[0, 0, 1], [-3, 1, 2], [0, -1, 2]], [[-1, 0, 1], [-1, -1, 2], [2, -3, 2]], [[-3, 1, 2], [-4, 1, 2], [0, -1, 1]], [[1, 0, 1], [3, -1, 2], [2, 1, 2]], [[-1, 1, 2], [2, -1, 2], [1, 0, 1]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[2, 3, 4, 5], [6, 1, 3, 2], [5, 4, 7, 8], [4, 9, 10, 7], [11, 13, 3, 1], [2, 5, 14, 12], [4, 3, 13, 9], [14, 5, 8, 15], [12, 13, 11, 0], [6, 2, 12, 0], [14, 9, 13, 12], [15, 10, 9, 14]]
        },
        "blue": {
          "prototypeVector": [[1, 0, 1], [0, 0, 1], [0, 0, 1]],
          "fullScaleVertices": [0, 1, 4, 7, 8],
          "halfScaleVertices": [],
          "vertices": [[[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [5, 6, 7, 4], [5, 4, 0, 3], [1, 7, 6, 2]]
        },
        "olive": {
          "prototypeVector": [[0, 1, 1], [0, 1, 1], [2, -1, 1]],
          "fullScaleVertices": [16, 17, 2, 18, 3, 7, 9, 13, 14, 15],
          "halfScaleVertices": [],
          "vertices": [[[-1, 2, 2], [1, 1, 2], [-1, 1, 1]], [[0, 1, 1], [-1, 2, 2], [-1, 1, 2]], [[-1, 0, 1], [-3, 0, 2], [1, -1, 2]], [[-3, 0, 2], [-1, -1, 2], [0, 0, 1]], [[1, 0, 1], [3, 0, 2], [-1, 1, 2]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[1, -2, 2], [-1, -1, 2], [1, -1, 1]], [[3, 0, 2], [1, 1, 2], [0, 0, 1]], [[0, -1, 1], [1, -2, 2], [1, -1, 2]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [4, 5, 6], [7, 8, 4, 9], [0, 10, 11], [1, 12, 8], [0, 3, 9, 4], [2, 14, 3], [7, 9, 15], [3, 14, 16], [17, 2, 7, 13], [7, 2, 1, 8], [8, 12, 5], [4, 8, 5], [10, 0, 4, 6], [7, 15, 13], [1, 11, 12], [2, 17, 14], [0, 11, 1], [3, 16, 9], [9, 16, 15]]
        },
        "coral": {
          "prototypeVector": [[-3, 3, 1], [0, 0, 1], [1, 0, 1]],
          "fullScaleVertices": [0, 1, 2, 7, 8, 9, 10, 14],
          "halfScaleVertices": [],
          "vertices": [[[-3, 0, 2], [1, -1, 2], [1, -1, 1]], [[-3, 0, 2], [1, -1, 2], [-1, 0, 1]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[3, 0, 2], [1, -1, 2], [-1, 1, 1]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[3, 0, 2], [-1, 1, 2], [-1, 1, 1]], [[-3, 0, 2], [-1, 1, 2], [-1, 0, 1]], [[0, -1, 2], [0, 0, 1], [-3, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-3, 0, 2], [-1, 1, 2], [1, -1, 1]], [[3, 0, 2], [1, -1, 2], [1, 0, 1]], [[0, 1, 2], [0, 0, 1], [3, -1, 2]], [[3, 0, 2], [-1, 1, 2], [1, 0, 1]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[1, 2, 0], [3, 4, 5, 6], [8, 7, 9], [7, 10, 9], [1, 8, 2], [11, 4, 3], [0, 2, 9, 10], [11, 3, 1, 0], [12, 11, 13], [7, 1, 3, 6], [13, 6, 5], [0, 10, 13, 11], [10, 7, 6, 13], [12, 13, 5], [8, 1, 7], [11, 12, 4]]
        },
        "sulfur": {
          "prototypeVector": [[-3, 3, 1], [2, -1, 1], [0, 0, 1]],
          "fullScaleVertices": [16, 0, 3, 8, 9, 10, 13, 14, 15],
          "halfScaleVertices": [],
          "vertices": [[[-9, 3, 2], [3, -2, 2], [-2, 1, 2]], [[9, -3, 2], [-5, 4, 2], [-2, 1, 2]], [[9, -3, 2], [-5, 4, 2], [2, -1, 2]], [[-9, 3, 2], [3, -2, 2], [2, -1, 2]], [[9, -3, 2], [-3, 2, 2], [-2, 1, 2]], [[9, -3, 2], [-3, 2, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-9, 3, 2], [5, -4, 2], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-9, 3, 2], [5, -4, 2], [-2, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [4, 5, 6, 7], [0, 3, 8, 9], [11, 1, 4, 7], [11, 12, 2, 1], [13, 3, 2, 5], [14, 10, 13, 15], [14, 15, 0, 9], [15, 13, 5, 4], [13, 10, 8, 3], [2, 12, 6, 5], [1, 0, 15, 4]]
        },
        "purple": {
          "prototypeVector": [[1, 1, 1], [1, 0, 1], [0, 0, 1]],
          "fullScaleVertices": [0, 1, 2, 18, 3, 4, 5, 9, 13, 14],
          "halfScaleVertices": [],
          "vertices": [[[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[0, -1, 1], [3, -3, 2], [2, -1, 2]], [[0, -1, 1], [3, -3, 2], [-2, 1, 2]], [[0, -1, 1], [1, -1, 2], [2, -1, 2]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]], [[0, 1, 1], [-1, 1, 2], [2, -1, 2]], [[0, 1, 1], [-3, 3, 2], [2, -1, 2]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, 1, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[0, -1, 1], [1, -1, 2], [-2, 1, 2]], [[0, 1, 1], [-3, 3, 2], [-2, 1, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[1, 2, 3], [6, 7, 8], [3, 5, 1], [10, 11, 6, 12], [2, 1, 13], [9, 0, 14, 4], [14, 3, 11, 15], [6, 2, 4, 7], [14, 0, 5], [2, 13, 4], [4, 13, 9], [16, 8, 7], [17, 15, 11], [8, 12, 6], [15, 16, 7], [15, 7, 4, 14], [11, 3, 2, 6], [15, 17, 16], [11, 10, 17], [14, 5, 3]]
        },
        "rose": {
          "prototypeVector": [[2, -1, 1], [-1, 2, 1], [0, 0, 1]],
          "fullScaleVertices": [16, 0, 1, 2, 3, 6, 7, 11, 15],
          "halfScaleVertices": [],
          "vertices": [[[3, -2, 2], [-2, -1, 2], [1, -1, 2]], [[-1, 0, 2], [-2, -1, 2], [1, -1, 2]], [[-2, 1, 2], [-1, 0, 1], [1, -1, 2]], [[2, -1, 2], [-1, 0, 1], [1, -1, 2]], [[-3, 2, 2], [2, 1, 2], [-1, 1, 2]], [[1, 0, 2], [2, 1, 2], [-1, 1, 2]], [[3, -2, 2], [-2, -1, 2], [-1, 1, 2]], [[-1, 0, 2], [-2, -1, 2], [-1, 1, 2]], [[-2, 1, 2], [1, 0, 1], [-1, 1, 2]], [[-3, 2, 2], [2, 1, 2], [1, -1, 2]], [[-2, 1, 2], [1, 0, 1], [1, -1, 2]], [[2, -1, 2], [-1, 0, 1], [-1, 1, 2]], [[2, -1, 2], [1, 0, 1], [-1, 1, 2]], [[2, -1, 2], [1, 0, 1], [1, -1, 2]], [[1, 0, 2], [2, 1, 2], [1, -1, 2]], [[-2, 1, 2], [-1, 0, 1], [-1, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [4, 5, 6, 7], [8, 4, 9, 10], [11, 6, 0, 3], [5, 12, 13, 14], [8, 12, 5, 4], [11, 15, 7, 6], [6, 5, 14, 0], [4, 7, 1, 9], [7, 15, 2, 1], [1, 0, 14, 9], [9, 14, 13, 10]]
        },
        "maroon": {
          "prototypeVector": [[-1, 1, 1], [3, -1, 1], [1, -1, 1]],
          "fullScaleVertices": [4, 5, 7, 8, 9, 10, 11, 12, 15],
          "halfScaleVertices": [],
          "vertices": [[[-1, 1, 2], [0, 1, 2], [1, -1, 1]], [[2, -1, 2], [1, 0, 1], [1, -1, 2]], [[1, 0, 2], [2, 0, 1], [0, -1, 2]], [[-1, 1, 1], [2, 1, 2], [1, -2, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[1, -2, 2], [0, -1, 1], [0, 1, 2]], [[1, 0, 1], [2, 1, 2], [-1, 0, 2]], [[1, -1, 1], [-2, -1, 2], [-1, 2, 2]], [[-2, 1, 2], [-1, 0, 1], [-1, 1, 2]], [[-1, 0, 2], [-2, 0, 1], [0, 1, 2]], [[-1, 0, 1], [-2, -1, 2], [1, 0, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[1, -1, 2], [0, -1, 2], [-1, 1, 1]], [[-1, 2, 2], [0, 1, 1], [0, -1, 2]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [5, 2, 6, 7], [8, 9, 10, 11], [3, 2, 5, 10], [0, 3, 13, 14], [7, 12, 15, 5], [9, 7, 6, 13], [13, 6, 16, 14], [2, 1, 16, 6], [3, 10, 9, 13], [10, 5, 15, 11], [8, 12, 7, 9]]
        },
        "lavender": {
          "prototypeVector": [[2, -1, 1], [0, 1, 1], [2, -1, 1]],
          "fullScaleVertices": [0, 1, 4, 5, 6, 7, 13, 14],
          "halfScaleVertices": [],
          "vertices": [[[1, -1, 1], [-2, -1, 2], [5, -4, 2]], [[3, -2, 2], [-2, 0, 1], [4, -3, 2]], [[-5, 4, 2], [0, 1, 1], [-4, 3, 2]], [[-3, 2, 1], [2, 1, 2], [-3, 2, 2]], [[5, -4, 2], [0, -1, 1], [4, -3, 2]], [[3, -2, 1], [-2, -1, 2], [3, -2, 2]], [[-2, 1, 2], [-1, 0, 1], [-1, 1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[-3, 2, 2], [2, 0, 1], [-4, 3, 2]], [[-1, 1, 1], [2, 1, 2], [-5, 4, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[2, -1, 2], [1, 0, 1], [1, -1, 2]], [[2, -1, 2], [1, 0, 1], [-1, 1, 2]], [[-2, 1, 2], [-1, 0, 1], [1, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [4, 5, 6, 7], [4, 0, 3, 8], [2, 9, 10], [8, 3, 11], [8, 11, 12], [9, 12, 10], [0, 4, 7], [9, 8, 12], [5, 1, 6], [8, 9, 5, 4], [3, 2, 10, 11], [1, 0, 13], [1, 13, 6], [0, 7, 13], [5, 9, 2, 1]]
        },
        "spruce": {
          "prototypeVector": [[-3, 2, 1], [-3, 2, 1], [5, -2, 1]],
          "fullScaleVertices": [0, 1, 6, 7, 10, 11, 12, 14],
          "halfScaleVertices": [],
          "vertices": [[[-1, 1, 2], [-2, 1, 2], [-1, 0, 1]], [[1, -1, 1], [-1, 0, 2], [-3, -1, 2]], [[-1, 1, 1], [-3, 2, 2], [3, 1, 2]], [[0, 0, 1], [-3, 2, 2], [3, 1, 2]], [[1, -1, 2], [2, -1, 2], [1, 0, 1]], [[-1, 1, 2], [2, -1, 2], [1, 0, 1]], [[0, 0, 1], [-1, 0, 2], [-3, -1, 2]], [[1, -1, 1], [3, -2, 2], [-3, -1, 2]], [[0, 0, 1], [3, -1, 2], [0, 1, 2]], [[0, 0, 1], [1, 0, 2], [3, 1, 2]], [[1, -1, 2], [-2, 1, 2], [-1, 0, 1]], [[0, 0, 1], [-3, 1, 2], [0, -1, 2]], [[0, 0, 1], [3, -2, 2], [-3, -1, 2]], [[-1, 1, 1], [1, 0, 2], [3, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[2, 3, 4, 5], [8, 4, 9], [10, 1, 11], [6, 1, 3, 2], [13, 9, 7, 12], [7, 1, 10], [12, 0, 6], [5, 13, 2], [9, 4, 3], [8, 9, 13], [0, 11, 6], [13, 12, 6, 2], [12, 7, 10, 0], [9, 3, 1, 7], [11, 1, 6], [8, 13, 5]]
        }
      }
    };
  });
  main.variable(observer("solid_connectors_normalized")).define("solid_connectors_normalized", function () {
    return {
      "name": "solid connectors",
      "connectorShape": {
        "vertices": [[[-1, 1, 2], [0, -1, 2], [-1, 1, 1]], [[0, 1, 2], [1, -1, 1], [-1, 1, 2]], [[-1, 1, 1], [1, -1, 2], [0, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[-1, 1, 1], [-1, 1, 2], [0, 1, 2]], [[0, 1, 2], [0, 0, 1], [3, -1, 2]], [[2, -1, 2], [-1, 0, 1], [-1, 1, 2]], [[-2, 1, 2], [-1, 0, 1], [-1, 1, 2]], [[-2, 1, 2], [-1, 0, 1], [1, -1, 2]], [[2, -1, 2], [-1, 0, 1], [1, -1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, 1, 2], [1, -1, 1], [1, -1, 2]], [[-1, 1, 1], [1, -1, 2], [0, -1, 2]], [[0, 1, 2], [0, 0, 1], [-3, 1, 2]], [[0, 0, 1], [3, -1, 2], [0, -1, 2]], [[-1, 1, 2], [0, 1, 2], [1, -1, 1]], [[-1, 1, 1], [-1, 1, 2], [0, -1, 2]], [[-1, 1, 2], [2, -1, 2], [-1, 0, 1]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, -1, 2], [0, -1, 2], [-1, 1, 1]], [[0, 0, 1], [-3, 1, 2], [0, 1, 2]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[-3, 1, 2], [0, 1, 2], [0, 0, 1]], [[0, -1, 2], [-1, 1, 1], [-1, 1, 2]], [[1, -1, 2], [0, 1, 2], [-1, 1, 1]], [[-2, 1, 2], [1, 0, 1], [-1, 1, 2]], [[-1, 1, 2], [-2, 1, 2], [-1, 0, 1]], [[2, -1, 2], [1, 0, 1], [-1, 1, 2]], [[-1, 1, 2], [0, 1, 2], [-1, 1, 1]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[0, 0, 1], [3, -1, 2], [0, 1, 2]], [[-1, 1, 2], [0, -1, 2], [1, -1, 1]], [[0, 0, 1], [-3, 1, 2], [0, -1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, -1, 2], [0, 0, 1], [3, -1, 2]], [[1, -1, 1], [-1, 1, 2], [0, 1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, -1, 2], [0, -1, 2], [1, -1, 1]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[2, -1, 2], [1, 0, 1], [1, -1, 2]], [[0, -1, 2], [-1, 1, 1], [1, -1, 2]], [[-2, 1, 2], [1, 0, 1], [1, -1, 2]], [[1, -1, 2], [0, 1, 2], [1, -1, 1]], [[1, -1, 1], [1, -1, 2], [0, 1, 2]], [[-1, 1, 2], [2, -1, 2], [1, 0, 1]], [[1, -1, 2], [2, -1, 2], [-1, 0, 1]], [[1, -1, 2], [2, -1, 2], [1, 0, 1]], [[1, -1, 2], [-2, 1, 2], [1, 0, 1]], [[-1, 1, 2], [-2, 1, 2], [1, 0, 1]], [[3, -1, 2], [0, -1, 2], [0, 0, 1]], [[0, -1, 2], [0, 0, 1], [-3, 1, 2]], [[1, -1, 1], [1, -1, 2], [0, -1, 2]], [[1, -1, 2], [-2, 1, 2], [-1, 0, 1]], [[1, -1, 1], [-1, 1, 2], [0, -1, 2]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]]],
        "polygons": [[9, 40, 35, 34, 10], [0, 1, 2], [33, 51, 49], [25, 36, 37, 38], [41, 55, 42], [9, 32, 59, 40], [20, 21, 52, 48], [26, 33, 30, 29, 27], [3, 4, 5, 6], [27, 29, 44, 46], [50, 57, 56, 55, 58], [26, 38, 51, 33], [45, 47, 58], [18, 28, 57, 50], [40, 59, 56], [31, 48, 37, 43], [7, 8, 9, 10], [36, 41, 42, 43], [24, 46, 47, 45], [4, 30, 5], [15, 47, 46, 44, 16], [15, 50, 58, 47], [24, 45, 41, 36, 25], [11, 14, 19], [3, 6, 39], [1, 39, 6, 2], [8, 32, 9], [11, 12, 13, 14], [16, 22, 17], [0, 21, 20, 8, 7], [12, 34, 13], [35, 40, 56, 57], [0, 7, 54, 1], [15, 16, 17, 18], [3, 19, 22, 23, 4], [7, 10, 54], [41, 45, 58, 55], [3, 39, 11, 19], [14, 17, 22, 19], [0, 2, 53, 21], [49, 51, 52, 53], [31, 43, 42, 59, 32], [15, 18, 50], [42, 55, 56, 59], [4, 23, 29, 30], [25, 38, 26], [13, 28, 18, 17, 14], [8, 20, 31, 32], [23, 44, 29], [24, 27, 46], [37, 48, 52, 51, 38], [20, 48, 31], [24, 25, 26, 27], [16, 44, 23, 22], [13, 34, 35, 28], [10, 34, 12, 54], [2, 6, 5, 49, 53], [36, 43, 37], [5, 30, 33, 49], [1, 54, 12, 11, 39], [28, 35, 57], [21, 53, 52]]
      },
      "strutGeometries": {
        "[[5,-3,2],[2,-1,2]]": {
          "name": "cinnamon",
          "prototypeVector": [[1, 0, 0], [5, -3, 2], [2, -1, 2]],
          "fullScaleVertices": [16, 0, 1, 2, 3, 4, 5, 11, 12],
          "halfScaleVertices": [],
          "vertices": [[[1, -2, 1], [6, -4, 1], [3, -2, 1]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, -2, 1], [5, -3, 1], [3, -2, 1]], [[1, -2, 1], [5, -3, 1], [1, -1, 1]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 2, 1], [-6, 4, 1], [-3, 2, 1]], [[-1, 2, 1], [-5, 3, 1], [-3, 2, 1]], [[-1, 2, 1], [-6, 4, 1], [-1, 1, 1]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[1, -2, 1], [6, -4, 1], [1, -1, 1]], [[-1, 2, 1], [-5, 3, 1], [-1, 1, 1]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]]],
          "polygons": [[0, 1, 2, 3], [6, 7, 8, 9], [4, 3, 2, 5], [4, 8, 10, 3], [13, 10, 14, 15], [9, 8, 4, 12], [12, 4, 5, 16], [0, 3, 10, 13], [12, 0, 13, 9], [7, 14, 10, 8], [12, 16, 1, 0], [9, 13, 15, 6]]
        },
        "[[2,-1,1],[5,-3,1]]": {
          "name": "green",
          "prototypeVector": [[1, 0, 0], [2, -1, 1], [5, -3, 1]],
          "fullScaleVertices": [0, 1, 2, 18, 3, 4, 8, 9, 10, 11],
          "halfScaleVertices": [],
          "vertices": [[[-2, -3, 4], [-5, 1, 4], [-7, 4, 4]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[-2, -3, 4], [-5, 1, 4], [-15, 8, 4]], [[-6, -1, 4], [-7, 3, 4], [-13, 8, 4]], [[-6, -1, 4], [-7, 3, 4], [-21, 12, 4]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[6, 1, 4], [7, -3, 4], [13, -8, 4]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[2, 3, 4], [5, -1, 4], [7, -4, 4]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[6, 1, 4], [7, -3, 4], [21, -12, 4]], [[2, 3, 4], [5, -1, 4], [15, -8, 4]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2], [5, 6, 7], [3, 8, 9], [4, 2, 10, 11], [12, 7, 2, 4], [13, 5, 12], [7, 14, 0, 2], [14, 15, 3, 0], [15, 12, 4, 3], [1, 10, 2], [9, 0, 3], [9, 1, 0], [16, 13, 15], [13, 12, 15], [6, 17, 14, 7], [3, 4, 11, 8], [5, 7, 12], [17, 16, 15, 14]]
        },
        "[[-1,1,2],[2,-1,2]]": {
          "name": "navy",
          "prototypeVector": [[1, 0, 0], [-1, 1, 2], [2, -1, 2]],
          "fullScaleVertices": [0, 16, 4, 5, 6, 7, 8, 9, 10, 12],
          "halfScaleVertices": [],
          "vertices": [[[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[1, 2, 2], [-1, 1, 1], [5, -3, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-5, -2, 4], [10, -7, 4], [-9, 5, 4]], [[-7, 2, 2], [1, -1, 1], [-3, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[-1, -2, 2], [1, -1, 1], [-5, 3, 2]], [[5, 2, 4], [-10, 7, 4], [9, -5, 4]], [[-11, 2, 4], [-2, -1, 4], [-7, 3, 4]], [[7, -2, 2], [-1, 1, 1], [3, -1, 2]], [[11, -2, 4], [2, 1, 4], [7, -3, 4]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]]],
          "polygons": [[1, 2, 3], [6, 5, 7], [9, 8, 10], [10, 8, 6], [8, 5, 6], [11, 1, 7, 12], [13, 10, 6, 14], [15, 14, 1, 3], [12, 7, 16], [13, 17, 11], [16, 7, 5], [2, 1, 11], [11, 17, 2], [13, 18, 17], [18, 14, 15], [7, 1, 14, 6], [13, 14, 18], [10, 12, 4, 9], [4, 12, 16], [10, 13, 11, 12]]
        },
        "[[-2,3,11],[-7,5,11]]": {
          "name": "black",
          "prototypeVector": [[1, 0, 0], [-2, 3, 11], [-7, 5, 11]],
          "fullScaleVertices": [1, 2, 4, 5, 6, 7, 11, 12, 14],
          "halfScaleVertices": [],
          "vertices": [[[-1, 3, 2], [0, 1, 2], [0, 0, 1]], [[1, -3, 2], [-2, 1, 2], [-2, 1, 1]], [[1, -3, 2], [-2, 1, 2], [0, 0, 1]], [[-1, 3, 2], [0, 1, 2], [2, -1, 1]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, -3, 2], [0, -1, 2], [-2, 1, 1]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 3, 2], [2, -1, 2], [0, 0, 1]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, -3, 2], [0, -1, 2], [0, 0, 1]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-1, 3, 2], [2, -1, 2], [2, -1, 1]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]]],
          "polygons": [[0, 1, 2, 3], [5, 6, 7, 1], [8, 9, 0, 10], [11, 2, 12, 4], [13, 11, 5, 9], [4, 6, 5, 11], [3, 2, 11, 13], [15, 13, 9, 8], [3, 13, 15, 16], [16, 10, 0, 3], [9, 5, 1, 0], [1, 7, 12, 2]]
        },
        "[[0,0,1],[2,-1,1]]": {
          "name": "yellow",
          "prototypeVector": [[1, 0, 0], [0, 0, 1], [2, -1, 1]],
          "fullScaleVertices": [4, 9, 11, 12],
          "halfScaleVertices": [2, 3, 6, 7, 8, 10],
          "vertices": [[[0, 1, 2], [0, 0, 1], [3, -1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, -1, 2], [-1, 1, 2], [-1, 0, 2]], [[-1, 0, 1], [0, 0, 1], [0, 0, 1]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, -1, 2], [1, -1, 2], [-1, 0, 2]], [[0, 1, 2], [-1, 1, 2], [1, 0, 2]], [[1, 0, 1], [0, 0, 1], [0, 0, 1]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[0, 1, 2], [1, -1, 2], [1, 0, 2]], [[0, -1, 2], [0, 0, 1], [-3, 1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]]],
          "polygons": [[0, 1, 2, 3], [5, 0, 3, 6], [3, 2, 7], [2, 6, 8], [6, 3, 10], [10, 7, 4, 12], [1, 5, 6, 2], [7, 8, 11, 4], [10, 8, 6], [8, 10, 12, 11], [8, 7, 2], [7, 10, 3]]
        },
        "[[2,-1,2],[-3,2,2]]": {
          "name": "turquoise",
          "prototypeVector": [[1, 0, 0], [2, -1, 2], [-3, 2, 2]],
          "fullScaleVertices": [0, 16, 1, 10, 11, 12, 13, 14, 15],
          "halfScaleVertices": [],
          "vertices": [[[1, -2, 1], [3, -2, 2], [-9, 5, 2]], [[1, -2, 1], [5, -4, 2], [-9, 5, 2]], [[-1, 2, 1], [-3, 2, 2], [5, -3, 2]], [[-1, 2, 1], [-5, 4, 2], [5, -3, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 2, 1], [-5, 4, 2], [9, -5, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, 2, 1], [-3, 2, 2], [9, -5, 2]], [[1, -2, 1], [5, -4, 2], [-5, 3, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, -2, 1], [3, -2, 2], [-5, 3, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]]],
          "polygons": [[0, 1, 2, 3], [2, 4, 5, 3], [6, 7, 8, 9], [11, 12, 10, 13], [9, 10, 12, 6], [9, 8, 4, 2], [15, 16, 1, 0], [2, 1, 10, 9], [0, 12, 11, 15], [3, 5, 7, 6], [13, 10, 1, 16], [0, 3, 6, 12]]
        },
        "[[2,-1,3],[5,-3,3]]": {
          "name": "brown",
          "prototypeVector": [[1, 0, 0], [2, -1, 3], [5, -3, 3]],
          "fullScaleVertices": [0, 16, 1, 6, 7, 8, 13, 14, 15],
          "halfScaleVertices": [],
          "vertices": [[[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-3, -3, 4], [-3, 2, 4], [2, -1, 4]], [[3, 3, 4], [3, -2, 4], [-2, 1, 4]], [[3, 3, 4], [3, -2, 4], [6, -3, 4]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-3, -3, 4], [-3, 2, 4], [-6, 3, 4]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-3, -3, 4], [1, -2, 4], [-6, 3, 4]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[3, 3, 4], [-1, 2, 4], [6, -3, 4]], [[3, 3, 4], [-1, 2, 4], [-2, 1, 4]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-3, -3, 4], [1, -2, 4], [2, -1, 4]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[2, 3, 4, 5], [9, 10, 11, 12], [3, 11, 10, 4], [7, 13, 8, 6], [14, 1, 11, 3], [0, 15, 1, 14], [12, 2, 5, 9], [13, 0, 14, 8], [6, 1, 15, 7], [8, 14, 3, 2], [6, 8, 2, 12], [12, 11, 1, 6]]
        },
        "[[-4,3,5],[3,-1,5]]": {
          "name": "orange",
          "prototypeVector": [[1, 0, 0], [-4, 3, 5], [3, -1, 5]],
          "fullScaleVertices": [0, 1, 2, 6, 7, 8, 10, 14],
          "halfScaleVertices": [],
          "vertices": [[[-2, -1, 2], [1, -1, 1], [-3, 1, 2]], [[0, -1, 2], [0, 0, 1], [-3, 1, 2]], [[0, -1, 1], [1, -1, 2], [0, -1, 2]], [[2, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[2, 1, 2], [0, 0, 1], [-1, 1, 2]], [[-2, -1, 2], [0, 0, 1], [1, -1, 2]], [[-2, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, 1, 1], [-1, 1, 2], [0, 1, 2]], [[0, 1, 2], [0, 0, 1], [3, -1, 2]], [[2, 1, 2], [-1, 1, 1], [3, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3, 4, 5], [1, 8, 6, 2], [3, 9, 4], [8, 10, 7], [5, 11, 7, 10, 0], [12, 11, 5, 4], [6, 8, 7, 11, 12, 13], [13, 9, 3, 2, 6], [10, 1, 0], [12, 9, 13]]
        },
        "[[-1,1,1],[0,0,1]]": {
          "name": "red",
          "prototypeVector": [[1, 0, 0], [-1, 1, 1], [0, 0, 1]],
          "fullScaleVertices": [16, 17, 18, 19, 7, 12],
          "halfScaleVertices": [0, 1, 2, 20, 5, 6, 8, 9, 10, 11],
          "vertices": [[[1, -1, 1], [-3, 1, 2], [-2, 1, 2]], [[0, 1, 2], [2, -1, 1], [1, -1, 2]], [[-3, 3, 2], [2, -1, 2], [0, 0, 1]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, -1, 1], [-3, 1, 2], [2, -1, 2]], [[0, -1, 2], [-2, 1, 1], [-1, 1, 2]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]], [[0, -1, 2], [-2, 1, 1], [1, -1, 2]], [[3, -3, 2], [-2, 1, 2], [0, 0, 1]], [[-1, 1, 1], [3, -1, 2], [-2, 1, 2]], [[-1, 1, 1], [3, -1, 2], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[0, 1, 2], [2, -1, 1], [-1, 1, 2]]],
          "polygons": [[0, 1, 2], [3, 4, 5, 6], [8, 9, 10], [9, 11, 10], [13, 14, 9, 8], [4, 15, 0, 5], [2, 1, 7, 16], [0, 8, 1], [14, 3, 6, 9], [8, 10, 1], [9, 6, 11], [5, 0, 2], [11, 20, 18, 17], [20, 2, 16, 18], [6, 5, 20], [1, 10, 12, 7], [6, 20, 11], [15, 13, 8, 0], [10, 11, 17, 12], [5, 2, 20]]
        },
        "[[2,-1,3],[-1,1,3]]": {
          "name": "apple",
          "prototypeVector": [[1, 0, 0], [2, -1, 3], [-1, 1, 3]],
          "fullScaleVertices": [0, 1, 4, 7, 8, 9, 10, 13, 14],
          "halfScaleVertices": [],
          "vertices": [[[-3, -3, 4], [-3, 2, 4], [-4, 1, 4]], [[-3, -3, 4], [1, -2, 4], [-4, 1, 4]], [[3, 3, 4], [3, -2, 4], [-4, 3, 4]], [[3, 3, 4], [-1, 2, 4], [-4, 3, 4]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[3, 3, 4], [-1, 2, 4], [4, -1, 4]], [[3, 3, 4], [3, -2, 4], [4, -1, 4]], [[-3, -3, 4], [1, -2, 4], [4, -3, 4]], [[-3, -3, 4], [-3, 2, 4], [4, -3, 4]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]]],
          "polygons": [[0, 1, 2, 3], [5, 6, 7, 8], [4, 10, 1, 0], [11, 12, 6, 5], [3, 5, 8, 0], [6, 2, 1, 7], [7, 1, 10, 9], [8, 7, 9, 14], [15, 2, 6, 12], [16, 11, 5, 3], [0, 8, 14, 4], [3, 2, 15, 16]]
        },
        "[[-8,5,1],[5,-3,1]]": {
          "name": "sand",
          "prototypeVector": [[1, 0, 0], [-8, 5, 1], [5, -3, 1]],
          "fullScaleVertices": [0, 16, 1, 2, 3, 6, 11, 12, 13],
          "halfScaleVertices": [],
          "vertices": [[[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, -2, 2], [-1, 0, 2], [-1, 0, 2]], [[-1, -2, 2], [-1, 0, 2], [3, -2, 2]], [[1, 2, 2], [3, -2, 2], [1, 0, 2]], [[1, 2, 2], [3, -2, 2], [-3, 2, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 2, 2], [1, 0, 2], [1, 0, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-1, -2, 2], [-3, 2, 2], [-1, 0, 2]], [[-1, -2, 2], [-3, 2, 2], [3, -2, 2]], [[1, 2, 2], [1, 0, 2], [-3, 2, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[2, 3, 4, 5], [6, 1, 3, 2], [5, 4, 7, 8], [4, 9, 10, 7], [11, 13, 3, 1], [2, 5, 14, 12], [4, 3, 13, 9], [14, 5, 8, 15], [12, 13, 11, 0], [6, 2, 12, 0], [14, 9, 13, 12], [15, 10, 9, 14]]
        },
        "[[0,0,1],[0,0,1]]": {
          "name": "blue",
          "prototypeVector": [[1, 0, 0], [0, 0, 1], [0, 0, 1]],
          "fullScaleVertices": [0, 1, 4, 7, 8],
          "halfScaleVertices": [],
          "vertices": [[[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [5, 6, 7, 4], [5, 4, 0, 3], [1, 7, 6, 2]]
        },
        "[[3,-1,5],[0,0,1]]": {
          "name": "olive",
          "prototypeVector": [[1, 0, 0], [3, -1, 5], [0, 0, 1]],
          "fullScaleVertices": [16, 17, 2, 18, 3, 7, 9, 13, 14, 15],
          "halfScaleVertices": [],
          "vertices": [[[2, 1, 2], [2, -1, 2], [-2, 1, 2]], [[2, 1, 2], [0, 1, 2], [-2, 1, 2]], [[-2, -1, 2], [-2, 1, 2], [-2, 1, 2]], [[-2, -1, 2], [0, -1, 2], [-2, 1, 2]], [[2, 1, 2], [2, -1, 2], [2, -1, 2]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-2, -1, 2], [-2, 1, 2], [2, -1, 2]], [[2, 1, 2], [0, 1, 2], [2, -1, 2]], [[-2, -1, 2], [0, -1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [4, 5, 6], [7, 8, 4, 9], [0, 10, 11], [1, 12, 8], [0, 3, 9, 4], [2, 14, 3], [7, 9, 15], [3, 14, 16], [17, 2, 7, 13], [7, 2, 1, 8], [8, 12, 5], [4, 8, 5], [10, 0, 4, 6], [7, 15, 13], [1, 11, 12], [2, 17, 14], [0, 11, 1], [3, 16, 9], [9, 16, 15]]
        },
        "[[-3,2,2],[-1,1,2]]": {
          "name": "coral",
          "prototypeVector": [[1, 0, 0], [-3, 2, 2], [-1, 1, 2]],
          "fullScaleVertices": [0, 1, 2, 7, 8, 9, 10, 14],
          "halfScaleVertices": [],
          "vertices": [[[2, -3, 2], [-2, 1, 2], [0, -1, 2]], [[0, -1, 1], [-1, 0, 2], [-3, 1, 2]], [[0, -1, 2], [0, 0, 1], [-3, 1, 2]], [[0, 1, 1], [3, -2, 2], [-1, 1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, 1, 2], [0, 0, 1], [3, -1, 2]], [[-2, 3, 2], [2, -1, 2], [0, 1, 2]], [[-2, -1, 2], [-2, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, -1, 1], [-3, 2, 2], [1, -1, 2]], [[2, 1, 2], [2, -1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, 1, 1], [1, 0, 2], [3, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[1, 2, 0], [3, 4, 5, 6], [8, 7, 9], [7, 10, 9], [1, 8, 2], [11, 4, 3], [0, 2, 9, 10], [11, 3, 1, 0], [12, 11, 13], [7, 1, 3, 6], [13, 6, 5], [0, 10, 13, 11], [10, 7, 6, 13], [12, 13, 5], [8, 1, 7], [11, 12, 4]]
        },
        "[[-1,1,3],[0,0,1]]": {
          "name": "sulfur",
          "prototypeVector": [[1, 0, 0], [-1, 1, 3], [0, 0, 1]],
          "fullScaleVertices": [16, 0, 3, 8, 9, 10, 13, 14, 15],
          "halfScaleVertices": [],
          "vertices": [[[-9, 3, 2], [3, -2, 2], [2, -1, 2]], [[9, -3, 2], [-5, 4, 2], [2, -1, 2]], [[9, -3, 2], [-5, 4, 2], [-2, 1, 2]], [[-9, 3, 2], [3, -2, 2], [-2, 1, 2]], [[9, -3, 2], [-3, 2, 2], [2, -1, 2]], [[9, -3, 2], [-3, 2, 2], [-2, 1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-9, 3, 2], [5, -4, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-9, 3, 2], [5, -4, 2], [2, -1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [4, 5, 6, 7], [0, 3, 8, 9], [11, 1, 4, 7], [11, 12, 2, 1], [13, 3, 2, 5], [14, 10, 13, 15], [14, 15, 0, 9], [15, 13, 5, 4], [13, 10, 8, 3], [2, 12, 6, 5], [1, 0, 15, 4]]
        },
        "[[2,-1,1],[0,0,1]]": {
          "name": "purple",
          "prototypeVector": [[1, 0, 0], [2, -1, 1], [0, 0, 1]],
          "fullScaleVertices": [0, 1, 2, 18, 3, 4, 5, 9, 13, 14],
          "halfScaleVertices": [],
          "vertices": [[[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[-3, 1, 2], [0, -1, 2], [0, 0, 1]], [[0, -1, 1], [3, -3, 2], [-2, 1, 2]], [[0, -1, 1], [3, -3, 2], [2, -1, 2]], [[0, -1, 1], [1, -1, 2], [-2, 1, 2]], [[0, -1, 2], [1, -1, 1], [-1, 1, 2]], [[0, 1, 1], [-1, 1, 2], [-2, 1, 2]], [[0, 1, 1], [-3, 3, 2], [-2, 1, 2]], [[0, 1, 2], [-1, 1, 1], [1, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[0, 1, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, -1, 2], [1, -1, 1], [1, -1, 2]], [[0, -1, 1], [1, -1, 2], [2, -1, 2]], [[0, 1, 1], [-3, 3, 2], [2, -1, 2]], [[3, -1, 2], [0, 1, 2], [0, 0, 1]], [[0, 1, 2], [-1, 1, 1], [-1, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[1, 2, 3], [6, 7, 8], [3, 5, 1], [10, 11, 6, 12], [2, 1, 13], [9, 0, 14, 4], [14, 3, 11, 15], [6, 2, 4, 7], [14, 0, 5], [2, 13, 4], [4, 13, 9], [16, 8, 7], [17, 15, 11], [8, 12, 6], [15, 16, 7], [15, 7, 4, 14], [11, 3, 2, 6], [15, 17, 16], [11, 10, 17], [14, 5, 3]]
        },
        "[[0,0,1],[-4,3,5]]": {
          "name": "rose",
          "prototypeVector": [[1, 0, 0], [0, 0, 1], [-4, 3, 5]],
          "fullScaleVertices": [16, 0, 1, 2, 3, 6, 7, 11, 15],
          "halfScaleVertices": [],
          "vertices": [[[-2, -1, 2], [1, -1, 2], [3, -2, 2]], [[-2, -1, 2], [1, -1, 2], [-1, 0, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[2, 1, 2], [-1, 1, 2], [-3, 2, 2]], [[2, 1, 2], [-1, 1, 2], [1, 0, 2]], [[-2, -1, 2], [-1, 1, 2], [3, -2, 2]], [[-2, -1, 2], [-1, 1, 2], [-1, 0, 2]], [[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[2, 1, 2], [1, -1, 2], [-3, 2, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[2, 1, 2], [1, -1, 2], [1, 0, 2]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [4, 5, 6, 7], [8, 4, 9, 10], [11, 6, 0, 3], [5, 12, 13, 14], [8, 12, 5, 4], [11, 15, 7, 6], [6, 5, 14, 0], [4, 7, 1, 9], [7, 15, 2, 1], [1, 0, 14, 9], [9, 14, 13, 10]]
        },
        "[[5,-3,1],[0,0,1]]": {
          "name": "maroon",
          "prototypeVector": [[1, 0, 0], [5, -3, 1], [0, 0, 1]],
          "fullScaleVertices": [4, 5, 7, 8, 9, 10, 11, 12, 15],
          "halfScaleVertices": [],
          "vertices": [[[1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 2, 2], [-1, 1, 1], [2, -1, 2]], [[1, 2, 2], [-1, 1, 1], [-2, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]], [[-1, -2, 2], [0, 0, 1], [2, -1, 2]], [[1, 2, 2], [0, 0, 1], [2, -1, 2]], [[-1, -2, 2], [1, -1, 1], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, -2, 2], [1, -1, 1], [-2, 1, 2]], [[-1, -2, 2], [0, 0, 1], [-2, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 2, 2], [0, 0, 1], [-2, 1, 2]], [[1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]]],
          "polygons": [[0, 1, 2, 3], [5, 2, 6, 7], [8, 9, 10, 11], [3, 2, 5, 10], [0, 3, 13, 14], [7, 12, 15, 5], [9, 7, 6, 13], [13, 6, 16, 14], [2, 1, 16, 6], [3, 10, 9, 13], [10, 5, 15, 11], [8, 12, 7, 9]]
        },
        "[[-3,2,1],[-3,2,1]]": {
          "name": "lavender",
          "prototypeVector": [[1, 0, 0], [-3, 2, 1], [-3, 2, 1]],
          "fullScaleVertices": [0, 1, 4, 5, 6, 7, 13, 14],
          "halfScaleVertices": [],
          "vertices": [[[-2, 0, 1], [4, -3, 2], [3, -2, 2]], [[-2, -1, 2], [5, -4, 2], [1, -1, 1]], [[2, 1, 2], [-3, 2, 2], [-3, 2, 1]], [[0, 1, 1], [-4, 3, 2], [-5, 4, 2]], [[-2, -1, 2], [3, -2, 2], [3, -2, 1]], [[0, -1, 1], [4, -3, 2], [5, -4, 2]], [[0, -1, 2], [0, 0, 1], [-3, 1, 2]], [[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[2, 1, 2], [-5, 4, 2], [-1, 1, 1]], [[2, 0, 1], [-4, 3, 2], [-3, 2, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[0, 1, 2], [0, 0, 1], [3, -1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[0, 1, 2, 3], [4, 5, 6, 7], [4, 0, 3, 8], [2, 9, 10], [8, 3, 11], [8, 11, 12], [9, 12, 10], [0, 4, 7], [9, 8, 12], [5, 1, 6], [8, 9, 5, 4], [3, 2, 10, 11], [1, 0, 13], [1, 13, 6], [0, 7, 13], [5, 9, 2, 1]]
        },
        "[[-5,4,11],[-5,4,11]]": {
          "name": "spruce",
          "prototypeVector": [[1, 0, 0], [-5, 4, 11], [-5, 4, 11]],
          "fullScaleVertices": [0, 1, 6, 7, 10, 11, 12, 14],
          "halfScaleVertices": [],
          "vertices": [[[-1, 0, 1], [-1, 1, 2], [-2, 1, 2]], [[-3, -1, 2], [1, -1, 1], [-1, 0, 2]], [[3, 1, 2], [-1, 1, 1], [-3, 2, 2]], [[3, 1, 2], [0, 0, 1], [-3, 2, 2]], [[1, 0, 1], [1, -1, 2], [2, -1, 2]], [[1, 0, 1], [-1, 1, 2], [2, -1, 2]], [[-3, -1, 2], [0, 0, 1], [-1, 0, 2]], [[-3, -1, 2], [1, -1, 1], [3, -2, 2]], [[0, 1, 2], [0, 0, 1], [3, -1, 2]], [[3, 1, 2], [0, 0, 1], [1, 0, 2]], [[-1, 0, 1], [1, -1, 2], [-2, 1, 2]], [[0, -1, 2], [0, 0, 1], [-3, 1, 2]], [[-3, -1, 2], [0, 0, 1], [3, -2, 2]], [[3, 1, 2], [-1, 1, 1], [1, 0, 2]], [[0, 0, 1], [0, 0, 1], [0, 0, 1]]],
          "polygons": [[2, 3, 4, 5], [8, 4, 9], [10, 1, 11], [6, 1, 3, 2], [13, 9, 7, 12], [7, 1, 10], [12, 0, 6], [5, 13, 2], [9, 4, 3], [8, 9, 13], [0, 11, 6], [13, 12, 6, 2], [12, 7, 10, 0], [9, 3, 1, 7], [11, 1, 6], [8, 13, 5]]
        }
      }
    };
  });
  main.variable(observer()).define(["md", "solid_connectors", "vprint"], function (md, solid_connectors, vprint) {
    return md(_templateObject44(), solid_connectors.strutGeometries.blue.vertices.map(vprint));
  });
  main.variable(observer("normalized_blue_vertices")).define("normalized_blue_vertices", ["md", "solid_connectors_normalized", "vprint"], function (md, solid_connectors_normalized, vprint) {
    return md(_templateObject45(), solid_connectors_normalized.strutGeometries["[[0,0,1],[0,0,1]]"].vertices.map(vprint));
  });
  main.variable(observer()).define(["orbit2", "solid_connectors"], function (orbit2, solid_connectors) {
    return orbit2(solid_connectors.strutGeometries.blue.prototypeVector);
  });
  main.variable(observer()).define(function () {
    var rgb_to_hex = function rgb_to_hex(rgb) {
      return '#' + rgb.map(function (x) {
        return ("0" + x.toString(16)).substr(-2, 2);
      }).join('');
    };

    var colorlist = [['red', [197, 36, 49]], ['yellow', [240, 169, 1]], ['blue', [6, 96, 141]], ['green', [8, 141, 50]], ['orange', [231, 101, 0]], ['purple', [122, 66, 171]], ['black', [40, 40, 42]], ['white', [238, 241, 247]], ['olive', [116, 104, 1]], ['lavender', [144, 127, 227]], ['maroon', [131, 17, 71]], ['rose', [252, 106, 171]], ['navy', [52, 48, 136]], ['brown', [105, 54, 1]], ['apple', [129, 191, 30]], ['sand', [187, 144, 85]], ['turquoise', [47, 174, 151]], ['coral', [254, 140, 139]], ['sulfur', [196, 231, 81]], ['cinnamon', [144, 56, 14]], ['spruce', [12, 84, 55]], ['magenta', [219, 41, 118]], ['snubPentagon', [170, 27, 111]], ['snubTriangle', [153, 158, 0]], ['snubDiagonal', [229, 221, 185]], ['slate', [102, 126, 153]], ['mauve', [146, 82, 131]], ['ivory', [229, 221, 185]]];
    return colorlist.map(function (_ref27) {
      var _ref28 = _slicedToArray(_ref27, 2),
          c = _ref28[0],
          rgb = _ref28[1];

      return "".concat(c, ": \"").concat(rgb_to_hex(rgb), "\"");
    }).join(',\n');
  });
  return main;
}